export interface GapMinder {
  /** country name */
  country: string
  /** continent name */
  continent: string
  /** measurement year */
  year: number
  /** country's avg. life expectancy (yrs) */
  lifeExp: number
  /** country's total population */
  pop: number
  /** country's GDP per capita (inflation-adjusted $) */
  gdpPercap: number
}

/**
 * **A subset of economic and health indicators for countries of the world between 1952 and 2007**. Based on free material from [gapminder.org](https://gapminder.org), CC-BY license.
 */
export const gapminder: GapMinder[] = [
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1952,
    lifeExp: 28.801,
    pop: 8425333,
    gdpPercap: 779.4453,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1957,
    lifeExp: 30.332,
    pop: 9240934,
    gdpPercap: 820.853,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1962,
    lifeExp: 31.997,
    pop: 10267083,
    gdpPercap: 853.1007,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1967,
    lifeExp: 34.02,
    pop: 11537966,
    gdpPercap: 836.1971,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1972,
    lifeExp: 36.088,
    pop: 13079460,
    gdpPercap: 739.9811,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1977,
    lifeExp: 38.438,
    pop: 14880372,
    gdpPercap: 786.1134,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1982,
    lifeExp: 39.854,
    pop: 12881816,
    gdpPercap: 978.0114,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1987,
    lifeExp: 40.822,
    pop: 13867957,
    gdpPercap: 852.3959,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1992,
    lifeExp: 41.674,
    pop: 16317921,
    gdpPercap: 649.3414,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 1997,
    lifeExp: 41.763,
    pop: 22227415,
    gdpPercap: 635.3414,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 2002,
    lifeExp: 42.129,
    pop: 25268405,
    gdpPercap: 726.7341,
  },
  {
    country: 'Afghanistan',
    continent: 'Asia',
    year: 2007,
    lifeExp: 43.828,
    pop: 31889923,
    gdpPercap: 974.5803,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1952,
    lifeExp: 55.23,
    pop: 1282697,
    gdpPercap: 1601.0561,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1957,
    lifeExp: 59.28,
    pop: 1476505,
    gdpPercap: 1942.2842,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1962,
    lifeExp: 64.82,
    pop: 1728137,
    gdpPercap: 2312.889,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1967,
    lifeExp: 66.22,
    pop: 1984060,
    gdpPercap: 2760.1969,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1972,
    lifeExp: 67.69,
    pop: 2263554,
    gdpPercap: 3313.4222,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1977,
    lifeExp: 68.93,
    pop: 2509048,
    gdpPercap: 3533.0039,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1982,
    lifeExp: 70.42,
    pop: 2780097,
    gdpPercap: 3630.8807,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1987,
    lifeExp: 72,
    pop: 3075321,
    gdpPercap: 3738.9327,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1992,
    lifeExp: 71.581,
    pop: 3326498,
    gdpPercap: 2497.4379,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 1997,
    lifeExp: 72.95,
    pop: 3428038,
    gdpPercap: 3193.0546,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 2002,
    lifeExp: 75.651,
    pop: 3508512,
    gdpPercap: 4604.2117,
  },
  {
    country: 'Albania',
    continent: 'Europe',
    year: 2007,
    lifeExp: 76.423,
    pop: 3600523,
    gdpPercap: 5937.0295,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1952,
    lifeExp: 43.077,
    pop: 9279525,
    gdpPercap: 2449.0082,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1957,
    lifeExp: 45.685,
    pop: 10270856,
    gdpPercap: 3013.976,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1962,
    lifeExp: 48.303,
    pop: 11000948,
    gdpPercap: 2550.8169,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1967,
    lifeExp: 51.407,
    pop: 12760499,
    gdpPercap: 3246.9918,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1972,
    lifeExp: 54.518,
    pop: 14760787,
    gdpPercap: 4182.6638,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1977,
    lifeExp: 58.014,
    pop: 17152804,
    gdpPercap: 4910.4168,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1982,
    lifeExp: 61.368,
    pop: 20033753,
    gdpPercap: 5745.1602,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1987,
    lifeExp: 65.799,
    pop: 23254956,
    gdpPercap: 5681.3585,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1992,
    lifeExp: 67.744,
    pop: 26298373,
    gdpPercap: 5023.2166,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 1997,
    lifeExp: 69.152,
    pop: 29072015,
    gdpPercap: 4797.2951,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 2002,
    lifeExp: 70.994,
    pop: 31287142,
    gdpPercap: 5288.0404,
  },
  {
    country: 'Algeria',
    continent: 'Africa',
    year: 2007,
    lifeExp: 72.301,
    pop: 33333216,
    gdpPercap: 6223.3675,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1952,
    lifeExp: 30.015,
    pop: 4232095,
    gdpPercap: 3520.6103,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1957,
    lifeExp: 31.999,
    pop: 4561361,
    gdpPercap: 3827.9405,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1962,
    lifeExp: 34,
    pop: 4826015,
    gdpPercap: 4269.2767,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1967,
    lifeExp: 35.985,
    pop: 5247469,
    gdpPercap: 5522.7764,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1972,
    lifeExp: 37.928,
    pop: 5894858,
    gdpPercap: 5473.288,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1977,
    lifeExp: 39.483,
    pop: 6162675,
    gdpPercap: 3008.6474,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1982,
    lifeExp: 39.942,
    pop: 7016384,
    gdpPercap: 2756.9537,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1987,
    lifeExp: 39.906,
    pop: 7874230,
    gdpPercap: 2430.2083,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1992,
    lifeExp: 40.647,
    pop: 8735988,
    gdpPercap: 2627.8457,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 1997,
    lifeExp: 40.963,
    pop: 9875024,
    gdpPercap: 2277.1409,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 2002,
    lifeExp: 41.003,
    pop: 10866106,
    gdpPercap: 2773.2873,
  },
  {
    country: 'Angola',
    continent: 'Africa',
    year: 2007,
    lifeExp: 42.731,
    pop: 12420476,
    gdpPercap: 4797.2313,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1952,
    lifeExp: 62.485,
    pop: 17876956,
    gdpPercap: 5911.3151,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1957,
    lifeExp: 64.399,
    pop: 19610538,
    gdpPercap: 6856.8562,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1962,
    lifeExp: 65.142,
    pop: 21283783,
    gdpPercap: 7133.166,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1967,
    lifeExp: 65.634,
    pop: 22934225,
    gdpPercap: 8052.953,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1972,
    lifeExp: 67.065,
    pop: 24779799,
    gdpPercap: 9443.0385,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1977,
    lifeExp: 68.481,
    pop: 26983828,
    gdpPercap: 10079.0267,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1982,
    lifeExp: 69.942,
    pop: 29341374,
    gdpPercap: 8997.8974,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1987,
    lifeExp: 70.774,
    pop: 31620918,
    gdpPercap: 9139.6714,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1992,
    lifeExp: 71.868,
    pop: 33958947,
    gdpPercap: 9308.4187,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 1997,
    lifeExp: 73.275,
    pop: 36203463,
    gdpPercap: 10967.282,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 2002,
    lifeExp: 74.34,
    pop: 38331121,
    gdpPercap: 8797.6407,
  },
  {
    country: 'Argentina',
    continent: 'Americas',
    year: 2007,
    lifeExp: 75.32,
    pop: 40301927,
    gdpPercap: 12779.3796,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1952,
    lifeExp: 69.12,
    pop: 8691212,
    gdpPercap: 10039.5956,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1957,
    lifeExp: 70.33,
    pop: 9712569,
    gdpPercap: 10949.6496,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1962,
    lifeExp: 70.93,
    pop: 10794968,
    gdpPercap: 12217.2269,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1967,
    lifeExp: 71.1,
    pop: 11872264,
    gdpPercap: 14526.1246,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1972,
    lifeExp: 71.93,
    pop: 13177000,
    gdpPercap: 16788.6295,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1977,
    lifeExp: 73.49,
    pop: 14074100,
    gdpPercap: 18334.1975,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1982,
    lifeExp: 74.74,
    pop: 15184200,
    gdpPercap: 19477.0093,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1987,
    lifeExp: 76.32,
    pop: 16257249,
    gdpPercap: 21888.889,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1992,
    lifeExp: 77.56,
    pop: 17481977,
    gdpPercap: 23424.7668,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 1997,
    lifeExp: 78.83,
    pop: 18565243,
    gdpPercap: 26997.9366,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 2002,
    lifeExp: 80.37,
    pop: 19546792,
    gdpPercap: 30687.7547,
  },
  {
    country: 'Australia',
    continent: 'Oceania',
    year: 2007,
    lifeExp: 81.235,
    pop: 20434176,
    gdpPercap: 34435.3674,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1952,
    lifeExp: 66.8,
    pop: 6927772,
    gdpPercap: 6137.0765,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1957,
    lifeExp: 67.48,
    pop: 6965860,
    gdpPercap: 8842.598,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1962,
    lifeExp: 69.54,
    pop: 7129864,
    gdpPercap: 10750.7211,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1967,
    lifeExp: 70.14,
    pop: 7376998,
    gdpPercap: 12834.6024,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1972,
    lifeExp: 70.63,
    pop: 7544201,
    gdpPercap: 16661.6256,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1977,
    lifeExp: 72.17,
    pop: 7568430,
    gdpPercap: 19749.4223,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1982,
    lifeExp: 73.18,
    pop: 7574613,
    gdpPercap: 21597.0836,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1987,
    lifeExp: 74.94,
    pop: 7578903,
    gdpPercap: 23687.8261,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1992,
    lifeExp: 76.04,
    pop: 7914969,
    gdpPercap: 27042.0187,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 1997,
    lifeExp: 77.51,
    pop: 8069876,
    gdpPercap: 29095.9207,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 2002,
    lifeExp: 78.98,
    pop: 8148312,
    gdpPercap: 32417.6077,
  },
  {
    country: 'Austria',
    continent: 'Europe',
    year: 2007,
    lifeExp: 79.829,
    pop: 8199783,
    gdpPercap: 36126.4927,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1952,
    lifeExp: 50.939,
    pop: 120447,
    gdpPercap: 9867.0848,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1957,
    lifeExp: 53.832,
    pop: 138655,
    gdpPercap: 11635.7995,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1962,
    lifeExp: 56.923,
    pop: 171863,
    gdpPercap: 12753.2751,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1967,
    lifeExp: 59.923,
    pop: 202182,
    gdpPercap: 14804.6727,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1972,
    lifeExp: 63.3,
    pop: 230800,
    gdpPercap: 18268.6584,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1977,
    lifeExp: 65.593,
    pop: 297410,
    gdpPercap: 19340.102,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1982,
    lifeExp: 69.052,
    pop: 377967,
    gdpPercap: 19211.1473,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1987,
    lifeExp: 70.75,
    pop: 454612,
    gdpPercap: 18524.0241,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1992,
    lifeExp: 72.601,
    pop: 529491,
    gdpPercap: 19035.5792,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 1997,
    lifeExp: 73.925,
    pop: 598561,
    gdpPercap: 20292.0168,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 2002,
    lifeExp: 74.795,
    pop: 656397,
    gdpPercap: 23403.5593,
  },
  {
    country: 'Bahrain',
    continent: 'Asia',
    year: 2007,
    lifeExp: 75.635,
    pop: 708573,
    gdpPercap: 29796.0483,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1952,
    lifeExp: 37.484,
    pop: 46886859,
    gdpPercap: 684.2442,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1957,
    lifeExp: 39.348,
    pop: 51365468,
    gdpPercap: 661.6375,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1962,
    lifeExp: 41.216,
    pop: 56839289,
    gdpPercap: 686.3416,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1967,
    lifeExp: 43.453,
    pop: 62821884,
    gdpPercap: 721.1861,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1972,
    lifeExp: 45.252,
    pop: 70759295,
    gdpPercap: 630.2336,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1977,
    lifeExp: 46.923,
    pop: 80428306,
    gdpPercap: 659.8772,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1982,
    lifeExp: 50.009,
    pop: 93074406,
    gdpPercap: 676.9819,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1987,
    lifeExp: 52.819,
    pop: 103764241,
    gdpPercap: 751.9794,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1992,
    lifeExp: 56.018,
    pop: 113704579,
    gdpPercap: 837.8102,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 1997,
    lifeExp: 59.412,
    pop: 123315288,
    gdpPercap: 972.77,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 2002,
    lifeExp: 62.013,
    pop: 135656790,
    gdpPercap: 1136.3904,
  },
  {
    country: 'Bangladesh',
    continent: 'Asia',
    year: 2007,
    lifeExp: 64.062,
    pop: 150448339,
    gdpPercap: 1391.2538,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1952,
    lifeExp: 68,
    pop: 8730405,
    gdpPercap: 8343.1051,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1957,
    lifeExp: 69.24,
    pop: 8989111,
    gdpPercap: 9714.9606,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1962,
    lifeExp: 70.25,
    pop: 9218400,
    gdpPercap: 10991.2068,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1967,
    lifeExp: 70.94,
    pop: 9556500,
    gdpPercap: 13149.0412,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1972,
    lifeExp: 71.44,
    pop: 9709100,
    gdpPercap: 16672.1436,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1977,
    lifeExp: 72.8,
    pop: 9821800,
    gdpPercap: 19117.9745,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1982,
    lifeExp: 73.93,
    pop: 9856303,
    gdpPercap: 20979.8459,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1987,
    lifeExp: 75.35,
    pop: 9870200,
    gdpPercap: 22525.5631,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1992,
    lifeExp: 76.46,
    pop: 10045622,
    gdpPercap: 25575.5707,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 1997,
    lifeExp: 77.53,
    pop: 10199787,
    gdpPercap: 27561.1966,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 2002,
    lifeExp: 78.32,
    pop: 10311970,
    gdpPercap: 30485.8838,
  },
  {
    country: 'Belgium',
    continent: 'Europe',
    year: 2007,
    lifeExp: 79.441,
    pop: 10392226,
    gdpPercap: 33692.6051,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1952,
    lifeExp: 38.223,
    pop: 1738315,
    gdpPercap: 1062.7522,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1957,
    lifeExp: 40.358,
    pop: 1925173,
    gdpPercap: 959.6011,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1962,
    lifeExp: 42.618,
    pop: 2151895,
    gdpPercap: 949.4991,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1967,
    lifeExp: 44.885,
    pop: 2427334,
    gdpPercap: 1035.8314,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1972,
    lifeExp: 47.014,
    pop: 2761407,
    gdpPercap: 1085.7969,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1977,
    lifeExp: 49.19,
    pop: 3168267,
    gdpPercap: 1029.1613,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1982,
    lifeExp: 50.904,
    pop: 3641603,
    gdpPercap: 1277.8976,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1987,
    lifeExp: 52.337,
    pop: 4243788,
    gdpPercap: 1225.856,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1992,
    lifeExp: 53.919,
    pop: 4981671,
    gdpPercap: 1191.2077,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 1997,
    lifeExp: 54.777,
    pop: 6066080,
    gdpPercap: 1232.9753,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 2002,
    lifeExp: 54.406,
    pop: 7026113,
    gdpPercap: 1372.8779,
  },
  {
    country: 'Benin',
    continent: 'Africa',
    year: 2007,
    lifeExp: 56.728,
    pop: 8078314,
    gdpPercap: 1441.2849,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1952,
    lifeExp: 40.414,
    pop: 2883315,
    gdpPercap: 2677.3263,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1957,
    lifeExp: 41.89,
    pop: 3211738,
    gdpPercap: 2127.6863,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1962,
    lifeExp: 43.428,
    pop: 3593918,
    gdpPercap: 2180.9725,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1967,
    lifeExp: 45.032,
    pop: 4040665,
    gdpPercap: 2586.8861,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1972,
    lifeExp: 46.714,
    pop: 4565872,
    gdpPercap: 2980.3313,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1977,
    lifeExp: 50.023,
    pop: 5079716,
    gdpPercap: 3548.0978,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1982,
    lifeExp: 53.859,
    pop: 5642224,
    gdpPercap: 3156.5105,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1987,
    lifeExp: 57.251,
    pop: 6156369,
    gdpPercap: 2753.6915,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1992,
    lifeExp: 59.957,
    pop: 6893451,
    gdpPercap: 2961.6997,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 1997,
    lifeExp: 62.05,
    pop: 7693188,
    gdpPercap: 3326.1432,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 2002,
    lifeExp: 63.883,
    pop: 8445134,
    gdpPercap: 3413.2627,
  },
  {
    country: 'Bolivia',
    continent: 'Americas',
    year: 2007,
    lifeExp: 65.554,
    pop: 9119152,
    gdpPercap: 3822.1371,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1952,
    lifeExp: 53.82,
    pop: 2791000,
    gdpPercap: 973.5332,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1957,
    lifeExp: 58.45,
    pop: 3076000,
    gdpPercap: 1353.9892,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1962,
    lifeExp: 61.93,
    pop: 3349000,
    gdpPercap: 1709.6837,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1967,
    lifeExp: 64.79,
    pop: 3585000,
    gdpPercap: 2172.3524,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1972,
    lifeExp: 67.45,
    pop: 3819000,
    gdpPercap: 2860.1698,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1977,
    lifeExp: 69.86,
    pop: 4086000,
    gdpPercap: 3528.4813,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1982,
    lifeExp: 70.69,
    pop: 4172693,
    gdpPercap: 4126.6132,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1987,
    lifeExp: 71.14,
    pop: 4338977,
    gdpPercap: 4314.1148,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1992,
    lifeExp: 72.178,
    pop: 4256013,
    gdpPercap: 2546.7814,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 1997,
    lifeExp: 73.244,
    pop: 3607000,
    gdpPercap: 4766.3559,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 2002,
    lifeExp: 74.09,
    pop: 4165416,
    gdpPercap: 6018.9752,
  },
  {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    year: 2007,
    lifeExp: 74.852,
    pop: 4552198,
    gdpPercap: 7446.2988,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1952,
    lifeExp: 47.622,
    pop: 442308,
    gdpPercap: 851.2411,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1957,
    lifeExp: 49.618,
    pop: 474639,
    gdpPercap: 918.2325,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1962,
    lifeExp: 51.52,
    pop: 512764,
    gdpPercap: 983.654,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1967,
    lifeExp: 53.298,
    pop: 553541,
    gdpPercap: 1214.7093,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1972,
    lifeExp: 56.024,
    pop: 619351,
    gdpPercap: 2263.6111,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1977,
    lifeExp: 59.319,
    pop: 781472,
    gdpPercap: 3214.8578,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1982,
    lifeExp: 61.484,
    pop: 970347,
    gdpPercap: 4551.1421,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1987,
    lifeExp: 63.622,
    pop: 1151184,
    gdpPercap: 6205.8839,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1992,
    lifeExp: 62.745,
    pop: 1342614,
    gdpPercap: 7954.1116,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 1997,
    lifeExp: 52.556,
    pop: 1536536,
    gdpPercap: 8647.1423,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 2002,
    lifeExp: 46.634,
    pop: 1630347,
    gdpPercap: 11003.6051,
  },
  {
    country: 'Botswana',
    continent: 'Africa',
    year: 2007,
    lifeExp: 50.728,
    pop: 1639131,
    gdpPercap: 12569.8518,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1952,
    lifeExp: 50.917,
    pop: 56602560,
    gdpPercap: 2108.9444,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1957,
    lifeExp: 53.285,
    pop: 65551171,
    gdpPercap: 2487.366,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1962,
    lifeExp: 55.665,
    pop: 76039390,
    gdpPercap: 3336.5858,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1967,
    lifeExp: 57.632,
    pop: 88049823,
    gdpPercap: 3429.8644,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1972,
    lifeExp: 59.504,
    pop: 100840058,
    gdpPercap: 4985.7115,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1977,
    lifeExp: 61.489,
    pop: 114313951,
    gdpPercap: 6660.1187,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1982,
    lifeExp: 63.336,
    pop: 128962939,
    gdpPercap: 7030.8359,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1987,
    lifeExp: 65.205,
    pop: 142938076,
    gdpPercap: 7807.0958,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1992,
    lifeExp: 67.057,
    pop: 155975974,
    gdpPercap: 6950.283,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 1997,
    lifeExp: 69.388,
    pop: 168546719,
    gdpPercap: 7957.9808,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 2002,
    lifeExp: 71.006,
    pop: 179914212,
    gdpPercap: 8131.2128,
  },
  {
    country: 'Brazil',
    continent: 'Americas',
    year: 2007,
    lifeExp: 72.39,
    pop: 190010647,
    gdpPercap: 9065.8008,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1952,
    lifeExp: 59.6,
    pop: 7274900,
    gdpPercap: 2444.2866,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1957,
    lifeExp: 66.61,
    pop: 7651254,
    gdpPercap: 3008.6707,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1962,
    lifeExp: 69.51,
    pop: 8012946,
    gdpPercap: 4254.3378,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1967,
    lifeExp: 70.42,
    pop: 8310226,
    gdpPercap: 5577.0028,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1972,
    lifeExp: 70.9,
    pop: 8576200,
    gdpPercap: 6597.4944,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.81,
    pop: 8797022,
    gdpPercap: 7612.2404,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1982,
    lifeExp: 71.08,
    pop: 8892098,
    gdpPercap: 8224.1916,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1987,
    lifeExp: 71.34,
    pop: 8971958,
    gdpPercap: 8239.8548,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1992,
    lifeExp: 71.19,
    pop: 8658506,
    gdpPercap: 6302.6234,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 1997,
    lifeExp: 70.32,
    pop: 8066057,
    gdpPercap: 5970.3888,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 2002,
    lifeExp: 72.14,
    pop: 7661799,
    gdpPercap: 7696.7777,
  },
  {
    country: 'Bulgaria',
    continent: 'Europe',
    year: 2007,
    lifeExp: 73.005,
    pop: 7322858,
    gdpPercap: 10680.7928,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1952,
    lifeExp: 31.975,
    pop: 4469979,
    gdpPercap: 543.2552,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1957,
    lifeExp: 34.906,
    pop: 4713416,
    gdpPercap: 617.1835,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1962,
    lifeExp: 37.814,
    pop: 4919632,
    gdpPercap: 722.512,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1967,
    lifeExp: 40.697,
    pop: 5127935,
    gdpPercap: 794.8266,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1972,
    lifeExp: 43.591,
    pop: 5433886,
    gdpPercap: 854.736,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1977,
    lifeExp: 46.137,
    pop: 5889574,
    gdpPercap: 743.387,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1982,
    lifeExp: 48.122,
    pop: 6634596,
    gdpPercap: 807.1986,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1987,
    lifeExp: 49.557,
    pop: 7586551,
    gdpPercap: 912.0631,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1992,
    lifeExp: 50.26,
    pop: 8878303,
    gdpPercap: 931.7528,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 1997,
    lifeExp: 50.324,
    pop: 10352843,
    gdpPercap: 946.295,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 2002,
    lifeExp: 50.65,
    pop: 12251209,
    gdpPercap: 1037.6452,
  },
  {
    country: 'Burkina Faso',
    continent: 'Africa',
    year: 2007,
    lifeExp: 52.295,
    pop: 14326203,
    gdpPercap: 1217.033,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1952,
    lifeExp: 39.031,
    pop: 2445618,
    gdpPercap: 339.2965,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1957,
    lifeExp: 40.533,
    pop: 2667518,
    gdpPercap: 379.5646,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1962,
    lifeExp: 42.045,
    pop: 2961915,
    gdpPercap: 355.2032,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1967,
    lifeExp: 43.548,
    pop: 3330989,
    gdpPercap: 412.9775,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1972,
    lifeExp: 44.057,
    pop: 3529983,
    gdpPercap: 464.0995,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1977,
    lifeExp: 45.91,
    pop: 3834415,
    gdpPercap: 556.1033,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1982,
    lifeExp: 47.471,
    pop: 4580410,
    gdpPercap: 559.6032,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1987,
    lifeExp: 48.211,
    pop: 5126023,
    gdpPercap: 621.8188,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1992,
    lifeExp: 44.736,
    pop: 5809236,
    gdpPercap: 631.6999,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 1997,
    lifeExp: 45.326,
    pop: 6121610,
    gdpPercap: 463.1151,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 2002,
    lifeExp: 47.36,
    pop: 7021078,
    gdpPercap: 446.4035,
  },
  {
    country: 'Burundi',
    continent: 'Africa',
    year: 2007,
    lifeExp: 49.58,
    pop: 8390505,
    gdpPercap: 430.0707,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1952,
    lifeExp: 39.417,
    pop: 4693836,
    gdpPercap: 368.4693,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1957,
    lifeExp: 41.366,
    pop: 5322536,
    gdpPercap: 434.0383,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1962,
    lifeExp: 43.415,
    pop: 6083619,
    gdpPercap: 496.9136,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1967,
    lifeExp: 45.415,
    pop: 6960067,
    gdpPercap: 523.4323,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1972,
    lifeExp: 40.317,
    pop: 7450606,
    gdpPercap: 421.624,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1977,
    lifeExp: 31.22,
    pop: 6978607,
    gdpPercap: 524.9722,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1982,
    lifeExp: 50.957,
    pop: 7272485,
    gdpPercap: 624.4755,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1987,
    lifeExp: 53.914,
    pop: 8371791,
    gdpPercap: 683.8956,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1992,
    lifeExp: 55.803,
    pop: 10150094,
    gdpPercap: 682.3032,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 1997,
    lifeExp: 56.534,
    pop: 11782962,
    gdpPercap: 734.2852,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 2002,
    lifeExp: 56.752,
    pop: 12926707,
    gdpPercap: 896.226,
  },
  {
    country: 'Cambodia',
    continent: 'Asia',
    year: 2007,
    lifeExp: 59.723,
    pop: 14131858,
    gdpPercap: 1713.7787,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1952,
    lifeExp: 38.523,
    pop: 5009067,
    gdpPercap: 1172.6677,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1957,
    lifeExp: 40.428,
    pop: 5359923,
    gdpPercap: 1313.0481,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1962,
    lifeExp: 42.643,
    pop: 5793633,
    gdpPercap: 1399.6074,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1967,
    lifeExp: 44.799,
    pop: 6335506,
    gdpPercap: 1508.4531,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1972,
    lifeExp: 47.049,
    pop: 7021028,
    gdpPercap: 1684.1465,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1977,
    lifeExp: 49.355,
    pop: 7959865,
    gdpPercap: 1783.4329,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1982,
    lifeExp: 52.961,
    pop: 9250831,
    gdpPercap: 2367.9833,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1987,
    lifeExp: 54.985,
    pop: 10780667,
    gdpPercap: 2602.6642,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1992,
    lifeExp: 54.314,
    pop: 12467171,
    gdpPercap: 1793.1633,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 1997,
    lifeExp: 52.199,
    pop: 14195809,
    gdpPercap: 1694.3375,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 2002,
    lifeExp: 49.856,
    pop: 15929988,
    gdpPercap: 1934.0114,
  },
  {
    country: 'Cameroon',
    continent: 'Africa',
    year: 2007,
    lifeExp: 50.43,
    pop: 17696293,
    gdpPercap: 2042.0952,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1952,
    lifeExp: 68.75,
    pop: 14785584,
    gdpPercap: 11367.1611,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1957,
    lifeExp: 69.96,
    pop: 17010154,
    gdpPercap: 12489.9501,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1962,
    lifeExp: 71.3,
    pop: 18985849,
    gdpPercap: 13462.4855,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1967,
    lifeExp: 72.13,
    pop: 20819767,
    gdpPercap: 16076.588,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1972,
    lifeExp: 72.88,
    pop: 22284500,
    gdpPercap: 18970.5709,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1977,
    lifeExp: 74.21,
    pop: 23796400,
    gdpPercap: 22090.8831,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1982,
    lifeExp: 75.76,
    pop: 25201900,
    gdpPercap: 22898.7921,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1987,
    lifeExp: 76.86,
    pop: 26549700,
    gdpPercap: 26626.515,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1992,
    lifeExp: 77.95,
    pop: 28523502,
    gdpPercap: 26342.8843,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 1997,
    lifeExp: 78.61,
    pop: 30305843,
    gdpPercap: 28954.9259,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 2002,
    lifeExp: 79.77,
    pop: 31902268,
    gdpPercap: 33328.9651,
  },
  {
    country: 'Canada',
    continent: 'Americas',
    year: 2007,
    lifeExp: 80.653,
    pop: 33390141,
    gdpPercap: 36319.235,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1952,
    lifeExp: 35.463,
    pop: 1291695,
    gdpPercap: 1071.3107,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1957,
    lifeExp: 37.464,
    pop: 1392284,
    gdpPercap: 1190.8443,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1962,
    lifeExp: 39.475,
    pop: 1523478,
    gdpPercap: 1193.0688,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1967,
    lifeExp: 41.478,
    pop: 1733638,
    gdpPercap: 1136.0566,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1972,
    lifeExp: 43.457,
    pop: 1927260,
    gdpPercap: 1070.0133,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1977,
    lifeExp: 46.775,
    pop: 2167533,
    gdpPercap: 1109.3743,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1982,
    lifeExp: 48.295,
    pop: 2476971,
    gdpPercap: 956.753,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1987,
    lifeExp: 50.485,
    pop: 2840009,
    gdpPercap: 844.8764,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1992,
    lifeExp: 49.396,
    pop: 3265124,
    gdpPercap: 747.9055,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 1997,
    lifeExp: 46.066,
    pop: 3696513,
    gdpPercap: 740.5063,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 2002,
    lifeExp: 43.308,
    pop: 4048013,
    gdpPercap: 738.6906,
  },
  {
    country: 'Central African Republic',
    continent: 'Africa',
    year: 2007,
    lifeExp: 44.741,
    pop: 4369038,
    gdpPercap: 706.0165,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1952,
    lifeExp: 38.092,
    pop: 2682462,
    gdpPercap: 1178.6659,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1957,
    lifeExp: 39.881,
    pop: 2894855,
    gdpPercap: 1308.4956,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1962,
    lifeExp: 41.716,
    pop: 3150417,
    gdpPercap: 1389.8176,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1967,
    lifeExp: 43.601,
    pop: 3495967,
    gdpPercap: 1196.8106,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1972,
    lifeExp: 45.569,
    pop: 3899068,
    gdpPercap: 1104.104,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1977,
    lifeExp: 47.383,
    pop: 4388260,
    gdpPercap: 1133.985,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1982,
    lifeExp: 49.517,
    pop: 4875118,
    gdpPercap: 797.9081,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1987,
    lifeExp: 51.051,
    pop: 5498955,
    gdpPercap: 952.3861,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1992,
    lifeExp: 51.724,
    pop: 6429417,
    gdpPercap: 1058.0643,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 1997,
    lifeExp: 51.573,
    pop: 7562011,
    gdpPercap: 1004.9614,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 2002,
    lifeExp: 50.525,
    pop: 8835739,
    gdpPercap: 1156.1819,
  },
  {
    country: 'Chad',
    continent: 'Africa',
    year: 2007,
    lifeExp: 50.651,
    pop: 10238807,
    gdpPercap: 1704.0637,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1952,
    lifeExp: 54.745,
    pop: 6377619,
    gdpPercap: 3939.9788,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1957,
    lifeExp: 56.074,
    pop: 7048426,
    gdpPercap: 4315.6227,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1962,
    lifeExp: 57.924,
    pop: 7961258,
    gdpPercap: 4519.0943,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1967,
    lifeExp: 60.523,
    pop: 8858908,
    gdpPercap: 5106.6543,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1972,
    lifeExp: 63.441,
    pop: 9717524,
    gdpPercap: 5494.0244,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1977,
    lifeExp: 67.052,
    pop: 10599793,
    gdpPercap: 4756.7638,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1982,
    lifeExp: 70.565,
    pop: 11487112,
    gdpPercap: 5095.6657,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1987,
    lifeExp: 72.492,
    pop: 12463354,
    gdpPercap: 5547.0638,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1992,
    lifeExp: 74.126,
    pop: 13572994,
    gdpPercap: 7596.126,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 1997,
    lifeExp: 75.816,
    pop: 14599929,
    gdpPercap: 10118.0532,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 2002,
    lifeExp: 77.86,
    pop: 15497046,
    gdpPercap: 10778.7838,
  },
  {
    country: 'Chile',
    continent: 'Americas',
    year: 2007,
    lifeExp: 78.553,
    pop: 16284741,
    gdpPercap: 13171.6388,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1952,
    lifeExp: 44,
    pop: 556263527,
    gdpPercap: 400.4486,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1957,
    lifeExp: 50.549,
    pop: 637408000,
    gdpPercap: 575.987,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1962,
    lifeExp: 44.5014,
    pop: 665770000,
    gdpPercap: 487.674,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1967,
    lifeExp: 58.3811,
    pop: 754550000,
    gdpPercap: 612.7057,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1972,
    lifeExp: 63.1189,
    pop: 862030000,
    gdpPercap: 676.9001,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1977,
    lifeExp: 63.9674,
    pop: 943455000,
    gdpPercap: 741.2375,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1982,
    lifeExp: 65.525,
    pop: 1000281000,
    gdpPercap: 962.4214,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1987,
    lifeExp: 67.274,
    pop: 1084035000,
    gdpPercap: 1378.904,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1992,
    lifeExp: 68.69,
    pop: 1164970000,
    gdpPercap: 1655.7842,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 1997,
    lifeExp: 70.426,
    pop: 1230075000,
    gdpPercap: 2289.2341,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 2002,
    lifeExp: 72.028,
    pop: 1280400000,
    gdpPercap: 3119.2809,
  },
  {
    country: 'China',
    continent: 'Asia',
    year: 2007,
    lifeExp: 72.961,
    pop: 1318683096,
    gdpPercap: 4959.1149,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1952,
    lifeExp: 50.643,
    pop: 12350771,
    gdpPercap: 2144.1151,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1957,
    lifeExp: 55.118,
    pop: 14485993,
    gdpPercap: 2323.8056,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1962,
    lifeExp: 57.863,
    pop: 17009885,
    gdpPercap: 2492.3511,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1967,
    lifeExp: 59.963,
    pop: 19764027,
    gdpPercap: 2678.7298,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1972,
    lifeExp: 61.623,
    pop: 22542890,
    gdpPercap: 3264.66,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1977,
    lifeExp: 63.837,
    pop: 25094412,
    gdpPercap: 3815.8079,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1982,
    lifeExp: 66.653,
    pop: 27764644,
    gdpPercap: 4397.5757,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1987,
    lifeExp: 67.768,
    pop: 30964245,
    gdpPercap: 4903.2191,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1992,
    lifeExp: 68.421,
    pop: 34202721,
    gdpPercap: 5444.6486,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 1997,
    lifeExp: 70.313,
    pop: 37657830,
    gdpPercap: 6117.3617,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 2002,
    lifeExp: 71.682,
    pop: 41008227,
    gdpPercap: 5755.26,
  },
  {
    country: 'Colombia',
    continent: 'Americas',
    year: 2007,
    lifeExp: 72.889,
    pop: 44227550,
    gdpPercap: 7006.5804,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1952,
    lifeExp: 40.715,
    pop: 153936,
    gdpPercap: 1102.9909,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1957,
    lifeExp: 42.46,
    pop: 170928,
    gdpPercap: 1211.1485,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1962,
    lifeExp: 44.467,
    pop: 191689,
    gdpPercap: 1406.6483,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1967,
    lifeExp: 46.472,
    pop: 217378,
    gdpPercap: 1876.0296,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1972,
    lifeExp: 48.944,
    pop: 250027,
    gdpPercap: 1937.5777,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1977,
    lifeExp: 50.939,
    pop: 304739,
    gdpPercap: 1172.603,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1982,
    lifeExp: 52.933,
    pop: 348643,
    gdpPercap: 1267.1001,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1987,
    lifeExp: 54.926,
    pop: 395114,
    gdpPercap: 1315.9808,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1992,
    lifeExp: 57.939,
    pop: 454429,
    gdpPercap: 1246.9074,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 1997,
    lifeExp: 60.66,
    pop: 527982,
    gdpPercap: 1173.6182,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 2002,
    lifeExp: 62.974,
    pop: 614382,
    gdpPercap: 1075.8116,
  },
  {
    country: 'Comoros',
    continent: 'Africa',
    year: 2007,
    lifeExp: 65.152,
    pop: 710960,
    gdpPercap: 986.1479,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1952,
    lifeExp: 39.143,
    pop: 14100005,
    gdpPercap: 780.5423,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1957,
    lifeExp: 40.652,
    pop: 15577932,
    gdpPercap: 905.8602,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1962,
    lifeExp: 42.122,
    pop: 17486434,
    gdpPercap: 896.3146,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1967,
    lifeExp: 44.056,
    pop: 19941073,
    gdpPercap: 861.5932,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1972,
    lifeExp: 45.989,
    pop: 23007669,
    gdpPercap: 904.8961,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1977,
    lifeExp: 47.804,
    pop: 26480870,
    gdpPercap: 795.7573,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1982,
    lifeExp: 47.784,
    pop: 30646495,
    gdpPercap: 673.7478,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1987,
    lifeExp: 47.412,
    pop: 35481645,
    gdpPercap: 672.7748,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1992,
    lifeExp: 45.548,
    pop: 41672143,
    gdpPercap: 457.7192,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 1997,
    lifeExp: 42.587,
    pop: 47798986,
    gdpPercap: 312.1884,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 2002,
    lifeExp: 44.966,
    pop: 55379852,
    gdpPercap: 241.1659,
  },
  {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    year: 2007,
    lifeExp: 46.462,
    pop: 64606759,
    gdpPercap: 277.5519,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1952,
    lifeExp: 42.111,
    pop: 854885,
    gdpPercap: 2125.6214,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1957,
    lifeExp: 45.053,
    pop: 940458,
    gdpPercap: 2315.0566,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1962,
    lifeExp: 48.435,
    pop: 1047924,
    gdpPercap: 2464.7832,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1967,
    lifeExp: 52.04,
    pop: 1179760,
    gdpPercap: 2677.9396,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1972,
    lifeExp: 54.907,
    pop: 1340458,
    gdpPercap: 3213.1527,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1977,
    lifeExp: 55.625,
    pop: 1536769,
    gdpPercap: 3259.179,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1982,
    lifeExp: 56.695,
    pop: 1774735,
    gdpPercap: 4879.5075,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1987,
    lifeExp: 57.47,
    pop: 2064095,
    gdpPercap: 4201.1949,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1992,
    lifeExp: 56.433,
    pop: 2409073,
    gdpPercap: 4016.2395,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 1997,
    lifeExp: 52.962,
    pop: 2800947,
    gdpPercap: 3484.1644,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 2002,
    lifeExp: 52.97,
    pop: 3328795,
    gdpPercap: 3484.062,
  },
  {
    country: 'Congo, Rep.',
    continent: 'Africa',
    year: 2007,
    lifeExp: 55.322,
    pop: 3800610,
    gdpPercap: 3632.5578,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1952,
    lifeExp: 57.206,
    pop: 926317,
    gdpPercap: 2627.0095,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1957,
    lifeExp: 60.026,
    pop: 1112300,
    gdpPercap: 2990.0108,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1962,
    lifeExp: 62.842,
    pop: 1345187,
    gdpPercap: 3460.937,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1967,
    lifeExp: 65.424,
    pop: 1588717,
    gdpPercap: 4161.7278,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1972,
    lifeExp: 67.849,
    pop: 1834796,
    gdpPercap: 5118.1469,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1977,
    lifeExp: 70.75,
    pop: 2108457,
    gdpPercap: 5926.877,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1982,
    lifeExp: 73.45,
    pop: 2424367,
    gdpPercap: 5262.7348,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1987,
    lifeExp: 74.752,
    pop: 2799811,
    gdpPercap: 5629.9153,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1992,
    lifeExp: 75.713,
    pop: 3173216,
    gdpPercap: 6160.4163,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 1997,
    lifeExp: 77.26,
    pop: 3518107,
    gdpPercap: 6677.0453,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 2002,
    lifeExp: 78.123,
    pop: 3834934,
    gdpPercap: 7723.4472,
  },
  {
    country: 'Costa Rica',
    continent: 'Americas',
    year: 2007,
    lifeExp: 78.782,
    pop: 4133884,
    gdpPercap: 9645.0614,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1952,
    lifeExp: 40.477,
    pop: 2977019,
    gdpPercap: 1388.5947,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1957,
    lifeExp: 42.469,
    pop: 3300000,
    gdpPercap: 1500.8959,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1962,
    lifeExp: 44.93,
    pop: 3832408,
    gdpPercap: 1728.8694,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1967,
    lifeExp: 47.35,
    pop: 4744870,
    gdpPercap: 2052.0505,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1972,
    lifeExp: 49.801,
    pop: 6071696,
    gdpPercap: 2378.2011,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1977,
    lifeExp: 52.374,
    pop: 7459574,
    gdpPercap: 2517.7365,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1982,
    lifeExp: 53.983,
    pop: 9025951,
    gdpPercap: 2602.7102,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1987,
    lifeExp: 54.655,
    pop: 10761098,
    gdpPercap: 2156.9561,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1992,
    lifeExp: 52.044,
    pop: 12772596,
    gdpPercap: 1648.0738,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 1997,
    lifeExp: 47.991,
    pop: 14625967,
    gdpPercap: 1786.2654,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 2002,
    lifeExp: 46.832,
    pop: 16252726,
    gdpPercap: 1648.8008,
  },
  {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    year: 2007,
    lifeExp: 48.328,
    pop: 18013409,
    gdpPercap: 1544.7501,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1952,
    lifeExp: 61.21,
    pop: 3882229,
    gdpPercap: 3119.2365,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1957,
    lifeExp: 64.77,
    pop: 3991242,
    gdpPercap: 4338.2316,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1962,
    lifeExp: 67.13,
    pop: 4076557,
    gdpPercap: 5477.89,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1967,
    lifeExp: 68.5,
    pop: 4174366,
    gdpPercap: 6960.2979,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1972,
    lifeExp: 69.61,
    pop: 4225310,
    gdpPercap: 9164.0901,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.64,
    pop: 4318673,
    gdpPercap: 11305.3852,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1982,
    lifeExp: 70.46,
    pop: 4413368,
    gdpPercap: 13221.8218,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1987,
    lifeExp: 71.52,
    pop: 4484310,
    gdpPercap: 13822.5839,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1992,
    lifeExp: 72.527,
    pop: 4494013,
    gdpPercap: 8447.7949,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 1997,
    lifeExp: 73.68,
    pop: 4444595,
    gdpPercap: 9875.6045,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 2002,
    lifeExp: 74.876,
    pop: 4481020,
    gdpPercap: 11628.389,
  },
  {
    country: 'Croatia',
    continent: 'Europe',
    year: 2007,
    lifeExp: 75.748,
    pop: 4493312,
    gdpPercap: 14619.2227,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1952,
    lifeExp: 59.421,
    pop: 6007797,
    gdpPercap: 5586.5388,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1957,
    lifeExp: 62.325,
    pop: 6640752,
    gdpPercap: 6092.1744,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1962,
    lifeExp: 65.246,
    pop: 7254373,
    gdpPercap: 5180.7559,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1967,
    lifeExp: 68.29,
    pop: 8139332,
    gdpPercap: 5690.268,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1972,
    lifeExp: 70.723,
    pop: 8831348,
    gdpPercap: 5305.4453,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1977,
    lifeExp: 72.649,
    pop: 9537988,
    gdpPercap: 6380.495,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1982,
    lifeExp: 73.717,
    pop: 9789224,
    gdpPercap: 7316.9181,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1987,
    lifeExp: 74.174,
    pop: 10239839,
    gdpPercap: 7532.9248,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1992,
    lifeExp: 74.414,
    pop: 10723260,
    gdpPercap: 5592.844,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 1997,
    lifeExp: 76.151,
    pop: 10983007,
    gdpPercap: 5431.9904,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 2002,
    lifeExp: 77.158,
    pop: 11226999,
    gdpPercap: 6340.6467,
  },
  {
    country: 'Cuba',
    continent: 'Americas',
    year: 2007,
    lifeExp: 78.273,
    pop: 11416987,
    gdpPercap: 8948.1029,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1952,
    lifeExp: 66.87,
    pop: 9125183,
    gdpPercap: 6876.1403,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1957,
    lifeExp: 69.03,
    pop: 9513758,
    gdpPercap: 8256.3439,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1962,
    lifeExp: 69.9,
    pop: 9620282,
    gdpPercap: 10136.8671,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1967,
    lifeExp: 70.38,
    pop: 9835109,
    gdpPercap: 11399.4449,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1972,
    lifeExp: 70.29,
    pop: 9862158,
    gdpPercap: 13108.4536,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.71,
    pop: 10161915,
    gdpPercap: 14800.1606,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1982,
    lifeExp: 70.96,
    pop: 10303704,
    gdpPercap: 15377.2285,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1987,
    lifeExp: 71.58,
    pop: 10311597,
    gdpPercap: 16310.4434,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1992,
    lifeExp: 72.4,
    pop: 10315702,
    gdpPercap: 14297.0212,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 1997,
    lifeExp: 74.01,
    pop: 10300707,
    gdpPercap: 16048.5142,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 2002,
    lifeExp: 75.51,
    pop: 10256295,
    gdpPercap: 17596.2102,
  },
  {
    country: 'Czech Republic',
    continent: 'Europe',
    year: 2007,
    lifeExp: 76.486,
    pop: 10228744,
    gdpPercap: 22833.3085,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1952,
    lifeExp: 70.78,
    pop: 4334000,
    gdpPercap: 9692.3852,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1957,
    lifeExp: 71.81,
    pop: 4487831,
    gdpPercap: 11099.6593,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1962,
    lifeExp: 72.35,
    pop: 4646899,
    gdpPercap: 13583.3135,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1967,
    lifeExp: 72.96,
    pop: 4838800,
    gdpPercap: 15937.2112,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1972,
    lifeExp: 73.47,
    pop: 4991596,
    gdpPercap: 18866.2072,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1977,
    lifeExp: 74.69,
    pop: 5088419,
    gdpPercap: 20422.9015,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1982,
    lifeExp: 74.63,
    pop: 5117810,
    gdpPercap: 21688.0405,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1987,
    lifeExp: 74.8,
    pop: 5127024,
    gdpPercap: 25116.1758,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1992,
    lifeExp: 75.33,
    pop: 5171393,
    gdpPercap: 26406.7399,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 1997,
    lifeExp: 76.11,
    pop: 5283663,
    gdpPercap: 29804.3457,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 2002,
    lifeExp: 77.18,
    pop: 5374693,
    gdpPercap: 32166.5001,
  },
  {
    country: 'Denmark',
    continent: 'Europe',
    year: 2007,
    lifeExp: 78.332,
    pop: 5468120,
    gdpPercap: 35278.4187,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1952,
    lifeExp: 34.812,
    pop: 63149,
    gdpPercap: 2669.5295,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1957,
    lifeExp: 37.328,
    pop: 71851,
    gdpPercap: 2864.9691,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1962,
    lifeExp: 39.693,
    pop: 89898,
    gdpPercap: 3020.9893,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1967,
    lifeExp: 42.074,
    pop: 127617,
    gdpPercap: 3020.0505,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1972,
    lifeExp: 44.366,
    pop: 178848,
    gdpPercap: 3694.2124,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1977,
    lifeExp: 46.519,
    pop: 228694,
    gdpPercap: 3081.761,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1982,
    lifeExp: 48.812,
    pop: 305991,
    gdpPercap: 2879.4681,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1987,
    lifeExp: 50.04,
    pop: 311025,
    gdpPercap: 2880.1026,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1992,
    lifeExp: 51.604,
    pop: 384156,
    gdpPercap: 2377.1562,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 1997,
    lifeExp: 53.157,
    pop: 417908,
    gdpPercap: 1895.017,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 2002,
    lifeExp: 53.373,
    pop: 447416,
    gdpPercap: 1908.2609,
  },
  {
    country: 'Djibouti',
    continent: 'Africa',
    year: 2007,
    lifeExp: 54.791,
    pop: 496374,
    gdpPercap: 2082.4816,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1952,
    lifeExp: 45.928,
    pop: 2491346,
    gdpPercap: 1397.7171,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1957,
    lifeExp: 49.828,
    pop: 2923186,
    gdpPercap: 1544.403,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1962,
    lifeExp: 53.459,
    pop: 3453434,
    gdpPercap: 1662.1374,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1967,
    lifeExp: 56.751,
    pop: 4049146,
    gdpPercap: 1653.723,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1972,
    lifeExp: 59.631,
    pop: 4671329,
    gdpPercap: 2189.8745,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1977,
    lifeExp: 61.788,
    pop: 5302800,
    gdpPercap: 2681.9889,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1982,
    lifeExp: 63.727,
    pop: 5968349,
    gdpPercap: 2861.0924,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1987,
    lifeExp: 66.046,
    pop: 6655297,
    gdpPercap: 2899.8422,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1992,
    lifeExp: 68.457,
    pop: 7351181,
    gdpPercap: 3044.2142,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 1997,
    lifeExp: 69.957,
    pop: 7992357,
    gdpPercap: 3614.1013,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 2002,
    lifeExp: 70.847,
    pop: 8650322,
    gdpPercap: 4563.8082,
  },
  {
    country: 'Dominican Republic',
    continent: 'Americas',
    year: 2007,
    lifeExp: 72.235,
    pop: 9319622,
    gdpPercap: 6025.3748,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1952,
    lifeExp: 48.357,
    pop: 3548753,
    gdpPercap: 3522.1107,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1957,
    lifeExp: 51.356,
    pop: 4058385,
    gdpPercap: 3780.5467,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1962,
    lifeExp: 54.64,
    pop: 4681707,
    gdpPercap: 4086.1141,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1967,
    lifeExp: 56.678,
    pop: 5432424,
    gdpPercap: 4579.0742,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1972,
    lifeExp: 58.796,
    pop: 6298651,
    gdpPercap: 5280.9947,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1977,
    lifeExp: 61.31,
    pop: 7278866,
    gdpPercap: 6679.6233,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1982,
    lifeExp: 64.342,
    pop: 8365850,
    gdpPercap: 7213.7913,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1987,
    lifeExp: 67.231,
    pop: 9545158,
    gdpPercap: 6481.777,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1992,
    lifeExp: 69.613,
    pop: 10748394,
    gdpPercap: 7103.7026,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 1997,
    lifeExp: 72.312,
    pop: 11911819,
    gdpPercap: 7429.4559,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 2002,
    lifeExp: 74.173,
    pop: 12921234,
    gdpPercap: 5773.0445,
  },
  {
    country: 'Ecuador',
    continent: 'Americas',
    year: 2007,
    lifeExp: 74.994,
    pop: 13755680,
    gdpPercap: 6873.2623,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1952,
    lifeExp: 41.893,
    pop: 22223309,
    gdpPercap: 1418.8224,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1957,
    lifeExp: 44.444,
    pop: 25009741,
    gdpPercap: 1458.9153,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1962,
    lifeExp: 46.992,
    pop: 28173309,
    gdpPercap: 1693.3359,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1967,
    lifeExp: 49.293,
    pop: 31681188,
    gdpPercap: 1814.8807,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1972,
    lifeExp: 51.137,
    pop: 34807417,
    gdpPercap: 2024.0081,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1977,
    lifeExp: 53.319,
    pop: 38783863,
    gdpPercap: 2785.4936,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1982,
    lifeExp: 56.006,
    pop: 45681811,
    gdpPercap: 3503.7296,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1987,
    lifeExp: 59.797,
    pop: 52799062,
    gdpPercap: 3885.4607,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1992,
    lifeExp: 63.674,
    pop: 59402198,
    gdpPercap: 3794.7552,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 1997,
    lifeExp: 67.217,
    pop: 66134291,
    gdpPercap: 4173.1818,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 2002,
    lifeExp: 69.806,
    pop: 73312559,
    gdpPercap: 4754.6044,
  },
  {
    country: 'Egypt',
    continent: 'Africa',
    year: 2007,
    lifeExp: 71.338,
    pop: 80264543,
    gdpPercap: 5581.181,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1952,
    lifeExp: 45.262,
    pop: 2042865,
    gdpPercap: 3048.3029,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1957,
    lifeExp: 48.57,
    pop: 2355805,
    gdpPercap: 3421.5232,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1962,
    lifeExp: 52.307,
    pop: 2747687,
    gdpPercap: 3776.8036,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1967,
    lifeExp: 55.855,
    pop: 3232927,
    gdpPercap: 4358.5954,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1972,
    lifeExp: 58.207,
    pop: 3790903,
    gdpPercap: 4520.246,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1977,
    lifeExp: 56.696,
    pop: 4282586,
    gdpPercap: 5138.9224,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1982,
    lifeExp: 56.604,
    pop: 4474873,
    gdpPercap: 4098.3442,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1987,
    lifeExp: 63.154,
    pop: 4842194,
    gdpPercap: 4140.4421,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1992,
    lifeExp: 66.798,
    pop: 5274649,
    gdpPercap: 4444.2317,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 1997,
    lifeExp: 69.535,
    pop: 5783439,
    gdpPercap: 5154.8255,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 2002,
    lifeExp: 70.734,
    pop: 6353681,
    gdpPercap: 5351.5687,
  },
  {
    country: 'El Salvador',
    continent: 'Americas',
    year: 2007,
    lifeExp: 71.878,
    pop: 6939688,
    gdpPercap: 5728.3535,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1952,
    lifeExp: 34.482,
    pop: 216964,
    gdpPercap: 375.6431,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1957,
    lifeExp: 35.983,
    pop: 232922,
    gdpPercap: 426.0964,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1962,
    lifeExp: 37.485,
    pop: 249220,
    gdpPercap: 582.842,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1967,
    lifeExp: 38.987,
    pop: 259864,
    gdpPercap: 915.596,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1972,
    lifeExp: 40.516,
    pop: 277603,
    gdpPercap: 672.4123,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1977,
    lifeExp: 42.024,
    pop: 192675,
    gdpPercap: 958.5668,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1982,
    lifeExp: 43.662,
    pop: 285483,
    gdpPercap: 927.8253,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1987,
    lifeExp: 45.664,
    pop: 341244,
    gdpPercap: 966.8968,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1992,
    lifeExp: 47.545,
    pop: 387838,
    gdpPercap: 1132.055,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 1997,
    lifeExp: 48.245,
    pop: 439971,
    gdpPercap: 2814.4808,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 2002,
    lifeExp: 49.348,
    pop: 495627,
    gdpPercap: 7703.4959,
  },
  {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    year: 2007,
    lifeExp: 51.579,
    pop: 551201,
    gdpPercap: 12154.0897,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1952,
    lifeExp: 35.928,
    pop: 1438760,
    gdpPercap: 328.9406,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1957,
    lifeExp: 38.047,
    pop: 1542611,
    gdpPercap: 344.1619,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1962,
    lifeExp: 40.158,
    pop: 1666618,
    gdpPercap: 380.9958,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1967,
    lifeExp: 42.189,
    pop: 1820319,
    gdpPercap: 468.795,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1972,
    lifeExp: 44.142,
    pop: 2260187,
    gdpPercap: 514.3242,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1977,
    lifeExp: 44.535,
    pop: 2512642,
    gdpPercap: 505.7538,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1982,
    lifeExp: 43.89,
    pop: 2637297,
    gdpPercap: 524.8758,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1987,
    lifeExp: 46.453,
    pop: 2915959,
    gdpPercap: 521.1341,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1992,
    lifeExp: 49.991,
    pop: 3668440,
    gdpPercap: 582.8585,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 1997,
    lifeExp: 53.378,
    pop: 4058319,
    gdpPercap: 913.4708,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 2002,
    lifeExp: 55.24,
    pop: 4414865,
    gdpPercap: 765.35,
  },
  {
    country: 'Eritrea',
    continent: 'Africa',
    year: 2007,
    lifeExp: 58.04,
    pop: 4906585,
    gdpPercap: 641.3695,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1952,
    lifeExp: 34.078,
    pop: 20860941,
    gdpPercap: 362.1463,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1957,
    lifeExp: 36.667,
    pop: 22815614,
    gdpPercap: 378.9042,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1962,
    lifeExp: 40.059,
    pop: 25145372,
    gdpPercap: 419.4564,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1967,
    lifeExp: 42.115,
    pop: 27860297,
    gdpPercap: 516.1186,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1972,
    lifeExp: 43.515,
    pop: 30770372,
    gdpPercap: 566.2439,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1977,
    lifeExp: 44.51,
    pop: 34617799,
    gdpPercap: 556.8084,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1982,
    lifeExp: 44.916,
    pop: 38111756,
    gdpPercap: 577.8607,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1987,
    lifeExp: 46.684,
    pop: 42999530,
    gdpPercap: 573.7413,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1992,
    lifeExp: 48.091,
    pop: 52088559,
    gdpPercap: 421.3535,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 1997,
    lifeExp: 49.402,
    pop: 59861301,
    gdpPercap: 515.8894,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 2002,
    lifeExp: 50.725,
    pop: 67946797,
    gdpPercap: 530.0535,
  },
  {
    country: 'Ethiopia',
    continent: 'Africa',
    year: 2007,
    lifeExp: 52.947,
    pop: 76511887,
    gdpPercap: 690.8056,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1952,
    lifeExp: 66.55,
    pop: 4090500,
    gdpPercap: 6424.5191,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1957,
    lifeExp: 67.49,
    pop: 4324000,
    gdpPercap: 7545.4154,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1962,
    lifeExp: 68.75,
    pop: 4491443,
    gdpPercap: 9371.8426,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1967,
    lifeExp: 69.83,
    pop: 4605744,
    gdpPercap: 10921.6363,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1972,
    lifeExp: 70.87,
    pop: 4639657,
    gdpPercap: 14358.8759,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1977,
    lifeExp: 72.52,
    pop: 4738902,
    gdpPercap: 15605.4228,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1982,
    lifeExp: 74.55,
    pop: 4826933,
    gdpPercap: 18533.1576,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1987,
    lifeExp: 74.83,
    pop: 4931729,
    gdpPercap: 21141.0122,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1992,
    lifeExp: 75.7,
    pop: 5041039,
    gdpPercap: 20647.165,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 1997,
    lifeExp: 77.13,
    pop: 5134406,
    gdpPercap: 23723.9502,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 2002,
    lifeExp: 78.37,
    pop: 5193039,
    gdpPercap: 28204.5906,
  },
  {
    country: 'Finland',
    continent: 'Europe',
    year: 2007,
    lifeExp: 79.313,
    pop: 5238460,
    gdpPercap: 33207.0844,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1952,
    lifeExp: 67.41,
    pop: 42459667,
    gdpPercap: 7029.8093,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1957,
    lifeExp: 68.93,
    pop: 44310863,
    gdpPercap: 8662.8349,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1962,
    lifeExp: 70.51,
    pop: 47124000,
    gdpPercap: 10560.4855,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1967,
    lifeExp: 71.55,
    pop: 49569000,
    gdpPercap: 12999.9177,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1972,
    lifeExp: 72.38,
    pop: 51732000,
    gdpPercap: 16107.1917,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1977,
    lifeExp: 73.83,
    pop: 53165019,
    gdpPercap: 18292.6351,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1982,
    lifeExp: 74.89,
    pop: 54433565,
    gdpPercap: 20293.8975,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1987,
    lifeExp: 76.34,
    pop: 55630100,
    gdpPercap: 22066.4421,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1992,
    lifeExp: 77.46,
    pop: 57374179,
    gdpPercap: 24703.7961,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 1997,
    lifeExp: 78.64,
    pop: 58623428,
    gdpPercap: 25889.7849,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 2002,
    lifeExp: 79.59,
    pop: 59925035,
    gdpPercap: 28926.0323,
  },
  {
    country: 'France',
    continent: 'Europe',
    year: 2007,
    lifeExp: 80.657,
    pop: 61083916,
    gdpPercap: 30470.0167,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1952,
    lifeExp: 37.003,
    pop: 420702,
    gdpPercap: 4293.4765,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1957,
    lifeExp: 38.999,
    pop: 434904,
    gdpPercap: 4976.1981,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1962,
    lifeExp: 40.489,
    pop: 455661,
    gdpPercap: 6631.4592,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1967,
    lifeExp: 44.598,
    pop: 489004,
    gdpPercap: 8358.762,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1972,
    lifeExp: 48.69,
    pop: 537977,
    gdpPercap: 11401.9484,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1977,
    lifeExp: 52.79,
    pop: 706367,
    gdpPercap: 21745.5733,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1982,
    lifeExp: 56.564,
    pop: 753874,
    gdpPercap: 15113.3619,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1987,
    lifeExp: 60.19,
    pop: 880397,
    gdpPercap: 11864.4084,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1992,
    lifeExp: 61.366,
    pop: 985739,
    gdpPercap: 13522.1575,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 1997,
    lifeExp: 60.461,
    pop: 1126189,
    gdpPercap: 14722.8419,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 2002,
    lifeExp: 56.761,
    pop: 1299304,
    gdpPercap: 12521.7139,
  },
  {
    country: 'Gabon',
    continent: 'Africa',
    year: 2007,
    lifeExp: 56.735,
    pop: 1454867,
    gdpPercap: 13206.4845,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1952,
    lifeExp: 30,
    pop: 284320,
    gdpPercap: 485.2307,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1957,
    lifeExp: 32.065,
    pop: 323150,
    gdpPercap: 520.9267,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1962,
    lifeExp: 33.896,
    pop: 374020,
    gdpPercap: 599.6503,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1967,
    lifeExp: 35.857,
    pop: 439593,
    gdpPercap: 734.7829,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1972,
    lifeExp: 38.308,
    pop: 517101,
    gdpPercap: 756.0868,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1977,
    lifeExp: 41.842,
    pop: 608274,
    gdpPercap: 884.7553,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1982,
    lifeExp: 45.58,
    pop: 715523,
    gdpPercap: 835.8096,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1987,
    lifeExp: 49.265,
    pop: 848406,
    gdpPercap: 611.6589,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1992,
    lifeExp: 52.644,
    pop: 1025384,
    gdpPercap: 665.6244,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 1997,
    lifeExp: 55.861,
    pop: 1235767,
    gdpPercap: 653.7302,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 2002,
    lifeExp: 58.041,
    pop: 1457766,
    gdpPercap: 660.5856,
  },
  {
    country: 'Gambia',
    continent: 'Africa',
    year: 2007,
    lifeExp: 59.448,
    pop: 1688359,
    gdpPercap: 752.7497,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1952,
    lifeExp: 67.5,
    pop: 69145952,
    gdpPercap: 7144.1144,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1957,
    lifeExp: 69.1,
    pop: 71019069,
    gdpPercap: 10187.8267,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1962,
    lifeExp: 70.3,
    pop: 73739117,
    gdpPercap: 12902.4629,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1967,
    lifeExp: 70.8,
    pop: 76368453,
    gdpPercap: 14745.6256,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1972,
    lifeExp: 71,
    pop: 78717088,
    gdpPercap: 18016.1803,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1977,
    lifeExp: 72.5,
    pop: 78160773,
    gdpPercap: 20512.9212,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1982,
    lifeExp: 73.8,
    pop: 78335266,
    gdpPercap: 22031.5327,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1987,
    lifeExp: 74.847,
    pop: 77718298,
    gdpPercap: 24639.1857,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1992,
    lifeExp: 76.07,
    pop: 80597764,
    gdpPercap: 26505.3032,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 1997,
    lifeExp: 77.34,
    pop: 82011073,
    gdpPercap: 27788.8842,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 2002,
    lifeExp: 78.67,
    pop: 82350671,
    gdpPercap: 30035.802,
  },
  {
    country: 'Germany',
    continent: 'Europe',
    year: 2007,
    lifeExp: 79.406,
    pop: 82400996,
    gdpPercap: 32170.3744,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1952,
    lifeExp: 43.149,
    pop: 5581001,
    gdpPercap: 911.2989,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1957,
    lifeExp: 44.779,
    pop: 6391288,
    gdpPercap: 1043.5615,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1962,
    lifeExp: 46.452,
    pop: 7355248,
    gdpPercap: 1190.0411,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1967,
    lifeExp: 48.072,
    pop: 8490213,
    gdpPercap: 1125.6972,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1972,
    lifeExp: 49.875,
    pop: 9354120,
    gdpPercap: 1178.2237,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1977,
    lifeExp: 51.756,
    pop: 10538093,
    gdpPercap: 993.224,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1982,
    lifeExp: 53.744,
    pop: 11400338,
    gdpPercap: 876.0326,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1987,
    lifeExp: 55.729,
    pop: 14168101,
    gdpPercap: 847.0061,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1992,
    lifeExp: 57.501,
    pop: 16278738,
    gdpPercap: 925.0602,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 1997,
    lifeExp: 58.556,
    pop: 18418288,
    gdpPercap: 1005.2458,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 2002,
    lifeExp: 58.453,
    pop: 20550751,
    gdpPercap: 1111.9846,
  },
  {
    country: 'Ghana',
    continent: 'Africa',
    year: 2007,
    lifeExp: 60.022,
    pop: 22873338,
    gdpPercap: 1327.6089,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1952,
    lifeExp: 65.86,
    pop: 7733250,
    gdpPercap: 3530.6901,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1957,
    lifeExp: 67.86,
    pop: 8096218,
    gdpPercap: 4916.2999,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1962,
    lifeExp: 69.51,
    pop: 8448233,
    gdpPercap: 6017.1907,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1967,
    lifeExp: 71,
    pop: 8716441,
    gdpPercap: 8513.097,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1972,
    lifeExp: 72.34,
    pop: 8888628,
    gdpPercap: 12724.8296,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1977,
    lifeExp: 73.68,
    pop: 9308479,
    gdpPercap: 14195.5243,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1982,
    lifeExp: 75.24,
    pop: 9786480,
    gdpPercap: 15268.4209,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1987,
    lifeExp: 76.67,
    pop: 9974490,
    gdpPercap: 16120.5284,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1992,
    lifeExp: 77.03,
    pop: 10325429,
    gdpPercap: 17541.4963,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 1997,
    lifeExp: 77.869,
    pop: 10502372,
    gdpPercap: 18747.6981,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 2002,
    lifeExp: 78.256,
    pop: 10603863,
    gdpPercap: 22514.2548,
  },
  {
    country: 'Greece',
    continent: 'Europe',
    year: 2007,
    lifeExp: 79.483,
    pop: 10706290,
    gdpPercap: 27538.4119,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1952,
    lifeExp: 42.023,
    pop: 3146381,
    gdpPercap: 2428.2378,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1957,
    lifeExp: 44.142,
    pop: 3640876,
    gdpPercap: 2617.156,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1962,
    lifeExp: 46.954,
    pop: 4208858,
    gdpPercap: 2750.3644,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1967,
    lifeExp: 50.016,
    pop: 4690773,
    gdpPercap: 3242.5311,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1972,
    lifeExp: 53.738,
    pop: 5149581,
    gdpPercap: 4031.4083,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1977,
    lifeExp: 56.029,
    pop: 5703430,
    gdpPercap: 4879.9927,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1982,
    lifeExp: 58.137,
    pop: 6395630,
    gdpPercap: 4820.4948,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1987,
    lifeExp: 60.782,
    pop: 7326406,
    gdpPercap: 4246.486,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1992,
    lifeExp: 63.373,
    pop: 8486949,
    gdpPercap: 4439.4508,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 1997,
    lifeExp: 66.322,
    pop: 9803875,
    gdpPercap: 4684.3138,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 2002,
    lifeExp: 68.978,
    pop: 11178650,
    gdpPercap: 4858.3475,
  },
  {
    country: 'Guatemala',
    continent: 'Americas',
    year: 2007,
    lifeExp: 70.259,
    pop: 12572928,
    gdpPercap: 5186.05,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1952,
    lifeExp: 33.609,
    pop: 2664249,
    gdpPercap: 510.1965,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1957,
    lifeExp: 34.558,
    pop: 2876726,
    gdpPercap: 576.267,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1962,
    lifeExp: 35.753,
    pop: 3140003,
    gdpPercap: 686.3737,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1967,
    lifeExp: 37.197,
    pop: 3451418,
    gdpPercap: 708.7595,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1972,
    lifeExp: 38.842,
    pop: 3811387,
    gdpPercap: 741.6662,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1977,
    lifeExp: 40.762,
    pop: 4227026,
    gdpPercap: 874.6859,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1982,
    lifeExp: 42.891,
    pop: 4710497,
    gdpPercap: 857.2504,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1987,
    lifeExp: 45.552,
    pop: 5650262,
    gdpPercap: 805.5725,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1992,
    lifeExp: 48.576,
    pop: 6990574,
    gdpPercap: 794.3484,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 1997,
    lifeExp: 51.455,
    pop: 8048834,
    gdpPercap: 869.4498,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 2002,
    lifeExp: 53.676,
    pop: 8807818,
    gdpPercap: 945.5836,
  },
  {
    country: 'Guinea',
    continent: 'Africa',
    year: 2007,
    lifeExp: 56.007,
    pop: 9947814,
    gdpPercap: 942.6542,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1952,
    lifeExp: 32.5,
    pop: 580653,
    gdpPercap: 299.8503,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1957,
    lifeExp: 33.489,
    pop: 601095,
    gdpPercap: 431.7905,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1962,
    lifeExp: 34.488,
    pop: 627820,
    gdpPercap: 522.0344,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1967,
    lifeExp: 35.492,
    pop: 601287,
    gdpPercap: 715.5806,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1972,
    lifeExp: 36.486,
    pop: 625361,
    gdpPercap: 820.2246,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1977,
    lifeExp: 37.465,
    pop: 745228,
    gdpPercap: 764.726,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1982,
    lifeExp: 39.327,
    pop: 825987,
    gdpPercap: 838.124,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1987,
    lifeExp: 41.245,
    pop: 927524,
    gdpPercap: 736.4154,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1992,
    lifeExp: 43.266,
    pop: 1050938,
    gdpPercap: 745.5399,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 1997,
    lifeExp: 44.873,
    pop: 1193708,
    gdpPercap: 796.6645,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 2002,
    lifeExp: 45.504,
    pop: 1332459,
    gdpPercap: 575.7047,
  },
  {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    year: 2007,
    lifeExp: 46.388,
    pop: 1472041,
    gdpPercap: 579.2317,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1952,
    lifeExp: 37.579,
    pop: 3201488,
    gdpPercap: 1840.3669,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1957,
    lifeExp: 40.696,
    pop: 3507701,
    gdpPercap: 1726.8879,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1962,
    lifeExp: 43.59,
    pop: 3880130,
    gdpPercap: 1796.589,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1967,
    lifeExp: 46.243,
    pop: 4318137,
    gdpPercap: 1452.0577,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1972,
    lifeExp: 48.042,
    pop: 4698301,
    gdpPercap: 1654.4569,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1977,
    lifeExp: 49.923,
    pop: 4908554,
    gdpPercap: 1874.2989,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1982,
    lifeExp: 51.461,
    pop: 5198399,
    gdpPercap: 2011.1595,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1987,
    lifeExp: 53.636,
    pop: 5756203,
    gdpPercap: 1823.016,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1992,
    lifeExp: 55.089,
    pop: 6326682,
    gdpPercap: 1456.3095,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 1997,
    lifeExp: 56.671,
    pop: 6913545,
    gdpPercap: 1341.7269,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 2002,
    lifeExp: 58.137,
    pop: 7607651,
    gdpPercap: 1270.3649,
  },
  {
    country: 'Haiti',
    continent: 'Americas',
    year: 2007,
    lifeExp: 60.916,
    pop: 8502814,
    gdpPercap: 1201.6372,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1952,
    lifeExp: 41.912,
    pop: 1517453,
    gdpPercap: 2194.9262,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1957,
    lifeExp: 44.665,
    pop: 1770390,
    gdpPercap: 2220.4877,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1962,
    lifeExp: 48.041,
    pop: 2090162,
    gdpPercap: 2291.1568,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1967,
    lifeExp: 50.924,
    pop: 2500689,
    gdpPercap: 2538.2694,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1972,
    lifeExp: 53.884,
    pop: 2965146,
    gdpPercap: 2529.8423,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1977,
    lifeExp: 57.402,
    pop: 3055235,
    gdpPercap: 3203.2081,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1982,
    lifeExp: 60.909,
    pop: 3669448,
    gdpPercap: 3121.7608,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1987,
    lifeExp: 64.492,
    pop: 4372203,
    gdpPercap: 3023.0967,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1992,
    lifeExp: 66.399,
    pop: 5077347,
    gdpPercap: 3081.6946,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 1997,
    lifeExp: 67.659,
    pop: 5867957,
    gdpPercap: 3160.4549,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 2002,
    lifeExp: 68.565,
    pop: 6677328,
    gdpPercap: 3099.7287,
  },
  {
    country: 'Honduras',
    continent: 'Americas',
    year: 2007,
    lifeExp: 70.198,
    pop: 7483763,
    gdpPercap: 3548.3308,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1952,
    lifeExp: 60.96,
    pop: 2125900,
    gdpPercap: 3054.4212,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1957,
    lifeExp: 64.75,
    pop: 2736300,
    gdpPercap: 3629.0765,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1962,
    lifeExp: 67.65,
    pop: 3305200,
    gdpPercap: 4692.6483,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1967,
    lifeExp: 70,
    pop: 3722800,
    gdpPercap: 6197.9628,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1972,
    lifeExp: 72,
    pop: 4115700,
    gdpPercap: 8315.9281,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1977,
    lifeExp: 73.6,
    pop: 4583700,
    gdpPercap: 11186.1413,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1982,
    lifeExp: 75.45,
    pop: 5264500,
    gdpPercap: 14560.5305,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1987,
    lifeExp: 76.2,
    pop: 5584510,
    gdpPercap: 20038.4727,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1992,
    lifeExp: 77.601,
    pop: 5829696,
    gdpPercap: 24757.603,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 1997,
    lifeExp: 80,
    pop: 6495918,
    gdpPercap: 28377.6322,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 2002,
    lifeExp: 81.495,
    pop: 6762476,
    gdpPercap: 30209.0152,
  },
  {
    country: 'Hong Kong, China',
    continent: 'Asia',
    year: 2007,
    lifeExp: 82.208,
    pop: 6980412,
    gdpPercap: 39724.9787,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1952,
    lifeExp: 64.03,
    pop: 9504000,
    gdpPercap: 5263.6738,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1957,
    lifeExp: 66.41,
    pop: 9839000,
    gdpPercap: 6040.18,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1962,
    lifeExp: 67.96,
    pop: 10063000,
    gdpPercap: 7550.3599,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1967,
    lifeExp: 69.5,
    pop: 10223422,
    gdpPercap: 9326.6447,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1972,
    lifeExp: 69.76,
    pop: 10394091,
    gdpPercap: 10168.6561,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1977,
    lifeExp: 69.95,
    pop: 10637171,
    gdpPercap: 11674.8374,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1982,
    lifeExp: 69.39,
    pop: 10705535,
    gdpPercap: 12545.9907,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1987,
    lifeExp: 69.58,
    pop: 10612740,
    gdpPercap: 12986.48,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1992,
    lifeExp: 69.17,
    pop: 10348684,
    gdpPercap: 10535.6285,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 1997,
    lifeExp: 71.04,
    pop: 10244684,
    gdpPercap: 11712.7768,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 2002,
    lifeExp: 72.59,
    pop: 10083313,
    gdpPercap: 14843.9356,
  },
  {
    country: 'Hungary',
    continent: 'Europe',
    year: 2007,
    lifeExp: 73.338,
    pop: 9956108,
    gdpPercap: 18008.9444,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1952,
    lifeExp: 72.49,
    pop: 147962,
    gdpPercap: 7267.6884,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1957,
    lifeExp: 73.47,
    pop: 165110,
    gdpPercap: 9244.0014,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1962,
    lifeExp: 73.68,
    pop: 182053,
    gdpPercap: 10350.1591,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1967,
    lifeExp: 73.73,
    pop: 198676,
    gdpPercap: 13319.8957,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1972,
    lifeExp: 74.46,
    pop: 209275,
    gdpPercap: 15798.0636,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1977,
    lifeExp: 76.11,
    pop: 221823,
    gdpPercap: 19654.9625,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1982,
    lifeExp: 76.99,
    pop: 233997,
    gdpPercap: 23269.6075,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1987,
    lifeExp: 77.23,
    pop: 244676,
    gdpPercap: 26923.2063,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1992,
    lifeExp: 78.77,
    pop: 259012,
    gdpPercap: 25144.392,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 1997,
    lifeExp: 78.95,
    pop: 271192,
    gdpPercap: 28061.0997,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 2002,
    lifeExp: 80.5,
    pop: 288030,
    gdpPercap: 31163.202,
  },
  {
    country: 'Iceland',
    continent: 'Europe',
    year: 2007,
    lifeExp: 81.757,
    pop: 301931,
    gdpPercap: 36180.7892,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1952,
    lifeExp: 37.373,
    pop: 372000000,
    gdpPercap: 546.5657,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1957,
    lifeExp: 40.249,
    pop: 409000000,
    gdpPercap: 590.062,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1962,
    lifeExp: 43.605,
    pop: 454000000,
    gdpPercap: 658.3472,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1967,
    lifeExp: 47.193,
    pop: 506000000,
    gdpPercap: 700.7706,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1972,
    lifeExp: 50.651,
    pop: 567000000,
    gdpPercap: 724.0325,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1977,
    lifeExp: 54.208,
    pop: 634000000,
    gdpPercap: 813.3373,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1982,
    lifeExp: 56.596,
    pop: 708000000,
    gdpPercap: 855.7235,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1987,
    lifeExp: 58.553,
    pop: 788000000,
    gdpPercap: 976.5127,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1992,
    lifeExp: 60.223,
    pop: 872000000,
    gdpPercap: 1164.4068,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 1997,
    lifeExp: 61.765,
    pop: 959000000,
    gdpPercap: 1458.8174,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 2002,
    lifeExp: 62.879,
    pop: 1034172547,
    gdpPercap: 1746.7695,
  },
  {
    country: 'India',
    continent: 'Asia',
    year: 2007,
    lifeExp: 64.698,
    pop: 1110396331,
    gdpPercap: 2452.2104,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1952,
    lifeExp: 37.468,
    pop: 82052000,
    gdpPercap: 749.6817,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1957,
    lifeExp: 39.918,
    pop: 90124000,
    gdpPercap: 858.9003,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1962,
    lifeExp: 42.518,
    pop: 99028000,
    gdpPercap: 849.2898,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1967,
    lifeExp: 45.964,
    pop: 109343000,
    gdpPercap: 762.4318,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1972,
    lifeExp: 49.203,
    pop: 121282000,
    gdpPercap: 1111.1079,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1977,
    lifeExp: 52.702,
    pop: 136725000,
    gdpPercap: 1382.7021,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1982,
    lifeExp: 56.159,
    pop: 153343000,
    gdpPercap: 1516.873,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1987,
    lifeExp: 60.137,
    pop: 169276000,
    gdpPercap: 1748.357,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1992,
    lifeExp: 62.681,
    pop: 184816000,
    gdpPercap: 2383.1409,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 1997,
    lifeExp: 66.041,
    pop: 199278000,
    gdpPercap: 3119.3356,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 2002,
    lifeExp: 68.588,
    pop: 211060000,
    gdpPercap: 2873.9129,
  },
  {
    country: 'Indonesia',
    continent: 'Asia',
    year: 2007,
    lifeExp: 70.65,
    pop: 223547000,
    gdpPercap: 3540.6516,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1952,
    lifeExp: 44.869,
    pop: 17272000,
    gdpPercap: 3035.326,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1957,
    lifeExp: 47.181,
    pop: 19792000,
    gdpPercap: 3290.2576,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1962,
    lifeExp: 49.325,
    pop: 22874000,
    gdpPercap: 4187.3298,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1967,
    lifeExp: 52.469,
    pop: 26538000,
    gdpPercap: 5906.7318,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1972,
    lifeExp: 55.234,
    pop: 30614000,
    gdpPercap: 9613.8186,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1977,
    lifeExp: 57.702,
    pop: 35480679,
    gdpPercap: 11888.5951,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1982,
    lifeExp: 59.62,
    pop: 43072751,
    gdpPercap: 7608.3346,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1987,
    lifeExp: 63.04,
    pop: 51889696,
    gdpPercap: 6642.8814,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1992,
    lifeExp: 65.742,
    pop: 60397973,
    gdpPercap: 7235.6532,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 1997,
    lifeExp: 68.042,
    pop: 63327987,
    gdpPercap: 8263.5903,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 2002,
    lifeExp: 69.451,
    pop: 66907826,
    gdpPercap: 9240.762,
  },
  {
    country: 'Iran',
    continent: 'Asia',
    year: 2007,
    lifeExp: 70.964,
    pop: 69453570,
    gdpPercap: 11605.7145,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1952,
    lifeExp: 45.32,
    pop: 5441766,
    gdpPercap: 4129.7661,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1957,
    lifeExp: 48.437,
    pop: 6248643,
    gdpPercap: 6229.3336,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1962,
    lifeExp: 51.457,
    pop: 7240260,
    gdpPercap: 8341.7378,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1967,
    lifeExp: 54.459,
    pop: 8519282,
    gdpPercap: 8931.4598,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1972,
    lifeExp: 56.95,
    pop: 10061506,
    gdpPercap: 9576.0376,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1977,
    lifeExp: 60.413,
    pop: 11882916,
    gdpPercap: 14688.2351,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1982,
    lifeExp: 62.038,
    pop: 14173318,
    gdpPercap: 14517.9071,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1987,
    lifeExp: 65.044,
    pop: 16543189,
    gdpPercap: 11643.5727,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1992,
    lifeExp: 59.461,
    pop: 17861905,
    gdpPercap: 3745.6407,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 1997,
    lifeExp: 58.811,
    pop: 20775703,
    gdpPercap: 3076.2398,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 2002,
    lifeExp: 57.046,
    pop: 24001816,
    gdpPercap: 4390.7173,
  },
  {
    country: 'Iraq',
    continent: 'Asia',
    year: 2007,
    lifeExp: 59.545,
    pop: 27499638,
    gdpPercap: 4471.0619,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1952,
    lifeExp: 66.91,
    pop: 2952156,
    gdpPercap: 5210.2803,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1957,
    lifeExp: 68.9,
    pop: 2878220,
    gdpPercap: 5599.0779,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1962,
    lifeExp: 70.29,
    pop: 2830000,
    gdpPercap: 6631.5973,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1967,
    lifeExp: 71.08,
    pop: 2900100,
    gdpPercap: 7655.569,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1972,
    lifeExp: 71.28,
    pop: 3024400,
    gdpPercap: 9530.7729,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1977,
    lifeExp: 72.03,
    pop: 3271900,
    gdpPercap: 11150.9811,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1982,
    lifeExp: 73.1,
    pop: 3480000,
    gdpPercap: 12618.3214,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1987,
    lifeExp: 74.36,
    pop: 3539900,
    gdpPercap: 13872.8665,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1992,
    lifeExp: 75.467,
    pop: 3557761,
    gdpPercap: 17558.8155,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 1997,
    lifeExp: 76.122,
    pop: 3667233,
    gdpPercap: 24521.9471,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 2002,
    lifeExp: 77.783,
    pop: 3879155,
    gdpPercap: 34077.0494,
  },
  {
    country: 'Ireland',
    continent: 'Europe',
    year: 2007,
    lifeExp: 78.885,
    pop: 4109086,
    gdpPercap: 40675.9964,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1952,
    lifeExp: 65.39,
    pop: 1620914,
    gdpPercap: 4086.5221,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1957,
    lifeExp: 67.84,
    pop: 1944401,
    gdpPercap: 5385.2785,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1962,
    lifeExp: 69.39,
    pop: 2310904,
    gdpPercap: 7105.6307,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1967,
    lifeExp: 70.75,
    pop: 2693585,
    gdpPercap: 8393.7414,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1972,
    lifeExp: 71.63,
    pop: 3095893,
    gdpPercap: 12786.9322,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1977,
    lifeExp: 73.06,
    pop: 3495918,
    gdpPercap: 13306.6192,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1982,
    lifeExp: 74.45,
    pop: 3858421,
    gdpPercap: 15367.0292,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1987,
    lifeExp: 75.6,
    pop: 4203148,
    gdpPercap: 17122.4799,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1992,
    lifeExp: 76.93,
    pop: 4936550,
    gdpPercap: 18051.5225,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 1997,
    lifeExp: 78.269,
    pop: 5531387,
    gdpPercap: 20896.6092,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 2002,
    lifeExp: 79.696,
    pop: 6029529,
    gdpPercap: 21905.5951,
  },
  {
    country: 'Israel',
    continent: 'Asia',
    year: 2007,
    lifeExp: 80.745,
    pop: 6426679,
    gdpPercap: 25523.2771,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1952,
    lifeExp: 65.94,
    pop: 47666000,
    gdpPercap: 4931.4042,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1957,
    lifeExp: 67.81,
    pop: 49182000,
    gdpPercap: 6248.6562,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1962,
    lifeExp: 69.24,
    pop: 50843200,
    gdpPercap: 8243.5823,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1967,
    lifeExp: 71.06,
    pop: 52667100,
    gdpPercap: 10022.4013,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1972,
    lifeExp: 72.19,
    pop: 54365564,
    gdpPercap: 12269.2738,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1977,
    lifeExp: 73.48,
    pop: 56059245,
    gdpPercap: 14255.9847,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1982,
    lifeExp: 74.98,
    pop: 56535636,
    gdpPercap: 16537.4835,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1987,
    lifeExp: 76.42,
    pop: 56729703,
    gdpPercap: 19207.2348,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1992,
    lifeExp: 77.44,
    pop: 56840847,
    gdpPercap: 22013.6449,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 1997,
    lifeExp: 78.82,
    pop: 57479469,
    gdpPercap: 24675.0245,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 2002,
    lifeExp: 80.24,
    pop: 57926999,
    gdpPercap: 27968.0982,
  },
  {
    country: 'Italy',
    continent: 'Europe',
    year: 2007,
    lifeExp: 80.546,
    pop: 58147733,
    gdpPercap: 28569.7197,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1952,
    lifeExp: 58.53,
    pop: 1426095,
    gdpPercap: 2898.5309,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1957,
    lifeExp: 62.61,
    pop: 1535090,
    gdpPercap: 4756.5258,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1962,
    lifeExp: 65.61,
    pop: 1665128,
    gdpPercap: 5246.1075,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1967,
    lifeExp: 67.51,
    pop: 1861096,
    gdpPercap: 6124.7035,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1972,
    lifeExp: 69,
    pop: 1997616,
    gdpPercap: 7433.8893,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1977,
    lifeExp: 70.11,
    pop: 2156814,
    gdpPercap: 6650.1956,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1982,
    lifeExp: 71.21,
    pop: 2298309,
    gdpPercap: 6068.0513,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1987,
    lifeExp: 71.77,
    pop: 2326606,
    gdpPercap: 6351.2375,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1992,
    lifeExp: 71.766,
    pop: 2378618,
    gdpPercap: 7404.9237,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 1997,
    lifeExp: 72.262,
    pop: 2531311,
    gdpPercap: 7121.9247,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 2002,
    lifeExp: 72.047,
    pop: 2664659,
    gdpPercap: 6994.7749,
  },
  {
    country: 'Jamaica',
    continent: 'Americas',
    year: 2007,
    lifeExp: 72.567,
    pop: 2780132,
    gdpPercap: 7320.8803,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1952,
    lifeExp: 63.03,
    pop: 86459025,
    gdpPercap: 3216.9563,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1957,
    lifeExp: 65.5,
    pop: 91563009,
    gdpPercap: 4317.6944,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1962,
    lifeExp: 68.73,
    pop: 95831757,
    gdpPercap: 6576.6495,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1967,
    lifeExp: 71.43,
    pop: 100825279,
    gdpPercap: 9847.7886,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1972,
    lifeExp: 73.42,
    pop: 107188273,
    gdpPercap: 14778.7864,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1977,
    lifeExp: 75.38,
    pop: 113872473,
    gdpPercap: 16610.377,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1982,
    lifeExp: 77.11,
    pop: 118454974,
    gdpPercap: 19384.1057,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1987,
    lifeExp: 78.67,
    pop: 122091325,
    gdpPercap: 22375.9419,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1992,
    lifeExp: 79.36,
    pop: 124329269,
    gdpPercap: 26824.8951,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 1997,
    lifeExp: 80.69,
    pop: 125956499,
    gdpPercap: 28816.585,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 2002,
    lifeExp: 82,
    pop: 127065841,
    gdpPercap: 28604.5919,
  },
  {
    country: 'Japan',
    continent: 'Asia',
    year: 2007,
    lifeExp: 82.603,
    pop: 127467972,
    gdpPercap: 31656.0681,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1952,
    lifeExp: 43.158,
    pop: 607914,
    gdpPercap: 1546.9078,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1957,
    lifeExp: 45.669,
    pop: 746559,
    gdpPercap: 1886.0806,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1962,
    lifeExp: 48.126,
    pop: 933559,
    gdpPercap: 2348.0092,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1967,
    lifeExp: 51.629,
    pop: 1255058,
    gdpPercap: 2741.7963,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1972,
    lifeExp: 56.528,
    pop: 1613551,
    gdpPercap: 2110.8563,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1977,
    lifeExp: 61.134,
    pop: 1937652,
    gdpPercap: 2852.3516,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1982,
    lifeExp: 63.739,
    pop: 2347031,
    gdpPercap: 4161.416,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1987,
    lifeExp: 65.869,
    pop: 2820042,
    gdpPercap: 4448.6799,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1992,
    lifeExp: 68.015,
    pop: 3867409,
    gdpPercap: 3431.5936,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 1997,
    lifeExp: 69.772,
    pop: 4526235,
    gdpPercap: 3645.3796,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 2002,
    lifeExp: 71.263,
    pop: 5307470,
    gdpPercap: 3844.9172,
  },
  {
    country: 'Jordan',
    continent: 'Asia',
    year: 2007,
    lifeExp: 72.535,
    pop: 6053193,
    gdpPercap: 4519.4612,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1952,
    lifeExp: 42.27,
    pop: 6464046,
    gdpPercap: 853.5409,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1957,
    lifeExp: 44.686,
    pop: 7454779,
    gdpPercap: 944.4383,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1962,
    lifeExp: 47.949,
    pop: 8678557,
    gdpPercap: 896.9664,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1967,
    lifeExp: 50.654,
    pop: 10191512,
    gdpPercap: 1056.7365,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1972,
    lifeExp: 53.559,
    pop: 12044785,
    gdpPercap: 1222.36,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1977,
    lifeExp: 56.155,
    pop: 14500404,
    gdpPercap: 1267.6132,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1982,
    lifeExp: 58.766,
    pop: 17661452,
    gdpPercap: 1348.2258,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1987,
    lifeExp: 59.339,
    pop: 21198082,
    gdpPercap: 1361.9369,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1992,
    lifeExp: 59.285,
    pop: 25020539,
    gdpPercap: 1341.9217,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 1997,
    lifeExp: 54.407,
    pop: 28263827,
    gdpPercap: 1360.485,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 2002,
    lifeExp: 50.992,
    pop: 31386842,
    gdpPercap: 1287.5147,
  },
  {
    country: 'Kenya',
    continent: 'Africa',
    year: 2007,
    lifeExp: 54.11,
    pop: 35610177,
    gdpPercap: 1463.2493,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1952,
    lifeExp: 50.056,
    pop: 8865488,
    gdpPercap: 1088.2778,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1957,
    lifeExp: 54.081,
    pop: 9411381,
    gdpPercap: 1571.1347,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1962,
    lifeExp: 56.656,
    pop: 10917494,
    gdpPercap: 1621.6936,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1967,
    lifeExp: 59.942,
    pop: 12617009,
    gdpPercap: 2143.5406,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1972,
    lifeExp: 63.983,
    pop: 14781241,
    gdpPercap: 3701.6215,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1977,
    lifeExp: 67.159,
    pop: 16325320,
    gdpPercap: 4106.3012,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1982,
    lifeExp: 69.1,
    pop: 17647518,
    gdpPercap: 4106.5253,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1987,
    lifeExp: 70.647,
    pop: 19067554,
    gdpPercap: 4106.4923,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1992,
    lifeExp: 69.978,
    pop: 20711375,
    gdpPercap: 3726.0635,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 1997,
    lifeExp: 67.727,
    pop: 21585105,
    gdpPercap: 1690.7568,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 2002,
    lifeExp: 66.662,
    pop: 22215365,
    gdpPercap: 1646.7582,
  },
  {
    country: 'Korea, Dem. Rep.',
    continent: 'Asia',
    year: 2007,
    lifeExp: 67.297,
    pop: 23301725,
    gdpPercap: 1593.0655,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1952,
    lifeExp: 47.453,
    pop: 20947571,
    gdpPercap: 1030.5922,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1957,
    lifeExp: 52.681,
    pop: 22611552,
    gdpPercap: 1487.5935,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1962,
    lifeExp: 55.292,
    pop: 26420307,
    gdpPercap: 1536.3444,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1967,
    lifeExp: 57.716,
    pop: 30131000,
    gdpPercap: 2029.2281,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1972,
    lifeExp: 62.612,
    pop: 33505000,
    gdpPercap: 3030.8767,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1977,
    lifeExp: 64.766,
    pop: 36436000,
    gdpPercap: 4657.221,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1982,
    lifeExp: 67.123,
    pop: 39326000,
    gdpPercap: 5622.9425,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1987,
    lifeExp: 69.81,
    pop: 41622000,
    gdpPercap: 8533.0888,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1992,
    lifeExp: 72.244,
    pop: 43805450,
    gdpPercap: 12104.2787,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 1997,
    lifeExp: 74.647,
    pop: 46173816,
    gdpPercap: 15993.528,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 2002,
    lifeExp: 77.045,
    pop: 47969150,
    gdpPercap: 19233.9882,
  },
  {
    country: 'Korea, Rep.',
    continent: 'Asia',
    year: 2007,
    lifeExp: 78.623,
    pop: 49044790,
    gdpPercap: 23348.1397,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1952,
    lifeExp: 55.565,
    pop: 160000,
    gdpPercap: 108382.3529,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1957,
    lifeExp: 58.033,
    pop: 212846,
    gdpPercap: 113523.1329,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1962,
    lifeExp: 60.47,
    pop: 358266,
    gdpPercap: 95458.1118,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1967,
    lifeExp: 64.624,
    pop: 575003,
    gdpPercap: 80894.8833,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1972,
    lifeExp: 67.712,
    pop: 841934,
    gdpPercap: 109347.867,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1977,
    lifeExp: 69.343,
    pop: 1140357,
    gdpPercap: 59265.4771,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1982,
    lifeExp: 71.309,
    pop: 1497494,
    gdpPercap: 31354.0357,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1987,
    lifeExp: 74.174,
    pop: 1891487,
    gdpPercap: 28118.43,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1992,
    lifeExp: 75.19,
    pop: 1418095,
    gdpPercap: 34932.9196,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 1997,
    lifeExp: 76.156,
    pop: 1765345,
    gdpPercap: 40300.62,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 2002,
    lifeExp: 76.904,
    pop: 2111561,
    gdpPercap: 35110.1057,
  },
  {
    country: 'Kuwait',
    continent: 'Asia',
    year: 2007,
    lifeExp: 77.588,
    pop: 2505559,
    gdpPercap: 47306.9898,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1952,
    lifeExp: 55.928,
    pop: 1439529,
    gdpPercap: 4834.8041,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1957,
    lifeExp: 59.489,
    pop: 1647412,
    gdpPercap: 6089.7869,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1962,
    lifeExp: 62.094,
    pop: 1886848,
    gdpPercap: 5714.5606,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1967,
    lifeExp: 63.87,
    pop: 2186894,
    gdpPercap: 6006.983,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1972,
    lifeExp: 65.421,
    pop: 2680018,
    gdpPercap: 7486.3843,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1977,
    lifeExp: 66.099,
    pop: 3115787,
    gdpPercap: 8659.6968,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1982,
    lifeExp: 66.983,
    pop: 3086876,
    gdpPercap: 7640.5195,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1987,
    lifeExp: 67.926,
    pop: 3089353,
    gdpPercap: 5377.0913,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1992,
    lifeExp: 69.292,
    pop: 3219994,
    gdpPercap: 6890.8069,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 1997,
    lifeExp: 70.265,
    pop: 3430388,
    gdpPercap: 8754.9639,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 2002,
    lifeExp: 71.028,
    pop: 3677780,
    gdpPercap: 9313.9388,
  },
  {
    country: 'Lebanon',
    continent: 'Asia',
    year: 2007,
    lifeExp: 71.993,
    pop: 3921278,
    gdpPercap: 10461.0587,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1952,
    lifeExp: 42.138,
    pop: 748747,
    gdpPercap: 298.8462,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1957,
    lifeExp: 45.047,
    pop: 813338,
    gdpPercap: 335.9971,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1962,
    lifeExp: 47.747,
    pop: 893143,
    gdpPercap: 411.8006,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1967,
    lifeExp: 48.492,
    pop: 996380,
    gdpPercap: 498.639,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1972,
    lifeExp: 49.767,
    pop: 1116779,
    gdpPercap: 496.5816,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1977,
    lifeExp: 52.208,
    pop: 1251524,
    gdpPercap: 745.3695,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1982,
    lifeExp: 55.078,
    pop: 1411807,
    gdpPercap: 797.2631,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1987,
    lifeExp: 57.18,
    pop: 1599200,
    gdpPercap: 773.9932,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1992,
    lifeExp: 59.685,
    pop: 1803195,
    gdpPercap: 977.4863,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 1997,
    lifeExp: 55.558,
    pop: 1982823,
    gdpPercap: 1186.148,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 2002,
    lifeExp: 44.593,
    pop: 2046772,
    gdpPercap: 1275.1846,
  },
  {
    country: 'Lesotho',
    continent: 'Africa',
    year: 2007,
    lifeExp: 42.592,
    pop: 2012649,
    gdpPercap: 1569.3314,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1952,
    lifeExp: 38.48,
    pop: 863308,
    gdpPercap: 575.573,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1957,
    lifeExp: 39.486,
    pop: 975950,
    gdpPercap: 620.97,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1962,
    lifeExp: 40.502,
    pop: 1112796,
    gdpPercap: 634.1952,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1967,
    lifeExp: 41.536,
    pop: 1279406,
    gdpPercap: 713.6036,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1972,
    lifeExp: 42.614,
    pop: 1482628,
    gdpPercap: 803.0055,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1977,
    lifeExp: 43.764,
    pop: 1703617,
    gdpPercap: 640.3224,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1982,
    lifeExp: 44.852,
    pop: 1956875,
    gdpPercap: 572.1996,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1987,
    lifeExp: 46.027,
    pop: 2269414,
    gdpPercap: 506.1139,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1992,
    lifeExp: 40.802,
    pop: 1912974,
    gdpPercap: 636.6229,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 1997,
    lifeExp: 42.221,
    pop: 2200725,
    gdpPercap: 609.174,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 2002,
    lifeExp: 43.753,
    pop: 2814651,
    gdpPercap: 531.4824,
  },
  {
    country: 'Liberia',
    continent: 'Africa',
    year: 2007,
    lifeExp: 45.678,
    pop: 3193942,
    gdpPercap: 414.5073,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1952,
    lifeExp: 42.723,
    pop: 1019729,
    gdpPercap: 2387.5481,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1957,
    lifeExp: 45.289,
    pop: 1201578,
    gdpPercap: 3448.2844,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1962,
    lifeExp: 47.808,
    pop: 1441863,
    gdpPercap: 6757.0308,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1967,
    lifeExp: 50.227,
    pop: 1759224,
    gdpPercap: 18772.7517,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1972,
    lifeExp: 52.773,
    pop: 2183877,
    gdpPercap: 21011.4972,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1977,
    lifeExp: 57.442,
    pop: 2721783,
    gdpPercap: 21951.2118,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1982,
    lifeExp: 62.155,
    pop: 3344074,
    gdpPercap: 17364.2754,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1987,
    lifeExp: 66.234,
    pop: 3799845,
    gdpPercap: 11770.5898,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1992,
    lifeExp: 68.755,
    pop: 4364501,
    gdpPercap: 9640.1385,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 1997,
    lifeExp: 71.555,
    pop: 4759670,
    gdpPercap: 9467.4461,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 2002,
    lifeExp: 72.737,
    pop: 5368585,
    gdpPercap: 9534.6775,
  },
  {
    country: 'Libya',
    continent: 'Africa',
    year: 2007,
    lifeExp: 73.952,
    pop: 6036914,
    gdpPercap: 12057.4993,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1952,
    lifeExp: 36.681,
    pop: 4762912,
    gdpPercap: 1443.0117,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1957,
    lifeExp: 38.865,
    pop: 5181679,
    gdpPercap: 1589.2027,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1962,
    lifeExp: 40.848,
    pop: 5703324,
    gdpPercap: 1643.3871,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1967,
    lifeExp: 42.881,
    pop: 6334556,
    gdpPercap: 1634.0473,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1972,
    lifeExp: 44.851,
    pop: 7082430,
    gdpPercap: 1748.563,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1977,
    lifeExp: 46.881,
    pop: 8007166,
    gdpPercap: 1544.2286,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1982,
    lifeExp: 48.969,
    pop: 9171477,
    gdpPercap: 1302.8787,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1987,
    lifeExp: 49.35,
    pop: 10568642,
    gdpPercap: 1155.4419,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1992,
    lifeExp: 52.214,
    pop: 12210395,
    gdpPercap: 1040.6762,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 1997,
    lifeExp: 54.978,
    pop: 14165114,
    gdpPercap: 986.2959,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 2002,
    lifeExp: 57.286,
    pop: 16473477,
    gdpPercap: 894.6371,
  },
  {
    country: 'Madagascar',
    continent: 'Africa',
    year: 2007,
    lifeExp: 59.443,
    pop: 19167654,
    gdpPercap: 1044.7701,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1952,
    lifeExp: 36.256,
    pop: 2917802,
    gdpPercap: 369.1651,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1957,
    lifeExp: 37.207,
    pop: 3221238,
    gdpPercap: 416.3698,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1962,
    lifeExp: 38.41,
    pop: 3628608,
    gdpPercap: 427.9011,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1967,
    lifeExp: 39.487,
    pop: 4147252,
    gdpPercap: 495.5148,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1972,
    lifeExp: 41.766,
    pop: 4730997,
    gdpPercap: 584.622,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1977,
    lifeExp: 43.767,
    pop: 5637246,
    gdpPercap: 663.2237,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1982,
    lifeExp: 45.642,
    pop: 6502825,
    gdpPercap: 632.8039,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1987,
    lifeExp: 47.457,
    pop: 7824747,
    gdpPercap: 635.5174,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1992,
    lifeExp: 49.42,
    pop: 10014249,
    gdpPercap: 563.2,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 1997,
    lifeExp: 47.495,
    pop: 10419991,
    gdpPercap: 692.2758,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 2002,
    lifeExp: 45.009,
    pop: 11824495,
    gdpPercap: 665.4231,
  },
  {
    country: 'Malawi',
    continent: 'Africa',
    year: 2007,
    lifeExp: 48.303,
    pop: 13327079,
    gdpPercap: 759.3499,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1952,
    lifeExp: 48.463,
    pop: 6748378,
    gdpPercap: 1831.1329,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1957,
    lifeExp: 52.102,
    pop: 7739235,
    gdpPercap: 1810.067,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1962,
    lifeExp: 55.737,
    pop: 8906385,
    gdpPercap: 2036.8849,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1967,
    lifeExp: 59.371,
    pop: 10154878,
    gdpPercap: 2277.7424,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1972,
    lifeExp: 63.01,
    pop: 11441462,
    gdpPercap: 2849.0948,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1977,
    lifeExp: 65.256,
    pop: 12845381,
    gdpPercap: 3827.9216,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1982,
    lifeExp: 68,
    pop: 14441916,
    gdpPercap: 4920.356,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1987,
    lifeExp: 69.5,
    pop: 16331785,
    gdpPercap: 5249.8027,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1992,
    lifeExp: 70.693,
    pop: 18319502,
    gdpPercap: 7277.9128,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 1997,
    lifeExp: 71.938,
    pop: 20476091,
    gdpPercap: 10132.9096,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 2002,
    lifeExp: 73.044,
    pop: 22662365,
    gdpPercap: 10206.9779,
  },
  {
    country: 'Malaysia',
    continent: 'Asia',
    year: 2007,
    lifeExp: 74.241,
    pop: 24821286,
    gdpPercap: 12451.6558,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1952,
    lifeExp: 33.685,
    pop: 3838168,
    gdpPercap: 452.337,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1957,
    lifeExp: 35.307,
    pop: 4241884,
    gdpPercap: 490.3822,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1962,
    lifeExp: 36.936,
    pop: 4690372,
    gdpPercap: 496.1743,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1967,
    lifeExp: 38.487,
    pop: 5212416,
    gdpPercap: 545.0099,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1972,
    lifeExp: 39.977,
    pop: 5828158,
    gdpPercap: 581.3689,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1977,
    lifeExp: 41.714,
    pop: 6491649,
    gdpPercap: 686.3953,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1982,
    lifeExp: 43.916,
    pop: 6998256,
    gdpPercap: 618.0141,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1987,
    lifeExp: 46.364,
    pop: 7634008,
    gdpPercap: 684.1716,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1992,
    lifeExp: 48.388,
    pop: 8416215,
    gdpPercap: 739.0144,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 1997,
    lifeExp: 49.903,
    pop: 9384984,
    gdpPercap: 790.258,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 2002,
    lifeExp: 51.818,
    pop: 10580176,
    gdpPercap: 951.4098,
  },
  {
    country: 'Mali',
    continent: 'Africa',
    year: 2007,
    lifeExp: 54.467,
    pop: 12031795,
    gdpPercap: 1042.5816,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1952,
    lifeExp: 40.543,
    pop: 1022556,
    gdpPercap: 743.1159,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1957,
    lifeExp: 42.338,
    pop: 1076852,
    gdpPercap: 846.1203,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1962,
    lifeExp: 44.248,
    pop: 1146757,
    gdpPercap: 1055.896,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1967,
    lifeExp: 46.289,
    pop: 1230542,
    gdpPercap: 1421.1452,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1972,
    lifeExp: 48.437,
    pop: 1332786,
    gdpPercap: 1586.8518,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1977,
    lifeExp: 50.852,
    pop: 1456688,
    gdpPercap: 1497.4922,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1982,
    lifeExp: 53.599,
    pop: 1622136,
    gdpPercap: 1481.1502,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1987,
    lifeExp: 56.145,
    pop: 1841240,
    gdpPercap: 1421.6036,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1992,
    lifeExp: 58.333,
    pop: 2119465,
    gdpPercap: 1361.3698,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 1997,
    lifeExp: 60.43,
    pop: 2444741,
    gdpPercap: 1483.1361,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 2002,
    lifeExp: 62.247,
    pop: 2828858,
    gdpPercap: 1579.0195,
  },
  {
    country: 'Mauritania',
    continent: 'Africa',
    year: 2007,
    lifeExp: 64.164,
    pop: 3270065,
    gdpPercap: 1803.1515,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1952,
    lifeExp: 50.986,
    pop: 516556,
    gdpPercap: 1967.9557,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1957,
    lifeExp: 58.089,
    pop: 609816,
    gdpPercap: 2034.038,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1962,
    lifeExp: 60.246,
    pop: 701016,
    gdpPercap: 2529.0675,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1967,
    lifeExp: 61.557,
    pop: 789309,
    gdpPercap: 2475.3876,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1972,
    lifeExp: 62.944,
    pop: 851334,
    gdpPercap: 2575.4842,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1977,
    lifeExp: 64.93,
    pop: 913025,
    gdpPercap: 3710.983,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1982,
    lifeExp: 66.711,
    pop: 992040,
    gdpPercap: 3688.0377,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1987,
    lifeExp: 68.74,
    pop: 1042663,
    gdpPercap: 4783.5869,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1992,
    lifeExp: 69.745,
    pop: 1096202,
    gdpPercap: 6058.2538,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 1997,
    lifeExp: 70.736,
    pop: 1149818,
    gdpPercap: 7425.7053,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 2002,
    lifeExp: 71.954,
    pop: 1200206,
    gdpPercap: 9021.8159,
  },
  {
    country: 'Mauritius',
    continent: 'Africa',
    year: 2007,
    lifeExp: 72.801,
    pop: 1250882,
    gdpPercap: 10956.9911,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1952,
    lifeExp: 50.789,
    pop: 30144317,
    gdpPercap: 3478.1255,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1957,
    lifeExp: 55.19,
    pop: 35015548,
    gdpPercap: 4131.5466,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1962,
    lifeExp: 58.299,
    pop: 41121485,
    gdpPercap: 4581.6094,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1967,
    lifeExp: 60.11,
    pop: 47995559,
    gdpPercap: 5754.7339,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1972,
    lifeExp: 62.361,
    pop: 55984294,
    gdpPercap: 6809.4067,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1977,
    lifeExp: 65.032,
    pop: 63759976,
    gdpPercap: 7674.9291,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1982,
    lifeExp: 67.405,
    pop: 71640904,
    gdpPercap: 9611.1475,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1987,
    lifeExp: 69.498,
    pop: 80122492,
    gdpPercap: 8688.156,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1992,
    lifeExp: 71.455,
    pop: 88111030,
    gdpPercap: 9472.3843,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 1997,
    lifeExp: 73.67,
    pop: 95895146,
    gdpPercap: 9767.2975,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 2002,
    lifeExp: 74.902,
    pop: 102479927,
    gdpPercap: 10742.4405,
  },
  {
    country: 'Mexico',
    continent: 'Americas',
    year: 2007,
    lifeExp: 76.195,
    pop: 108700891,
    gdpPercap: 11977.575,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1952,
    lifeExp: 42.244,
    pop: 800663,
    gdpPercap: 786.5669,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1957,
    lifeExp: 45.248,
    pop: 882134,
    gdpPercap: 912.6626,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1962,
    lifeExp: 48.251,
    pop: 1010280,
    gdpPercap: 1056.354,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1967,
    lifeExp: 51.253,
    pop: 1149500,
    gdpPercap: 1226.0411,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1972,
    lifeExp: 53.754,
    pop: 1320500,
    gdpPercap: 1421.742,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1977,
    lifeExp: 55.491,
    pop: 1528000,
    gdpPercap: 1647.5117,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1982,
    lifeExp: 57.489,
    pop: 1756032,
    gdpPercap: 2000.6031,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1987,
    lifeExp: 60.222,
    pop: 2015133,
    gdpPercap: 2338.0083,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1992,
    lifeExp: 61.271,
    pop: 2312802,
    gdpPercap: 1785.402,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 1997,
    lifeExp: 63.625,
    pop: 2494803,
    gdpPercap: 1902.2521,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 2002,
    lifeExp: 65.033,
    pop: 2674234,
    gdpPercap: 2140.7393,
  },
  {
    country: 'Mongolia',
    continent: 'Asia',
    year: 2007,
    lifeExp: 66.803,
    pop: 2874127,
    gdpPercap: 3095.7723,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1952,
    lifeExp: 59.164,
    pop: 413834,
    gdpPercap: 2647.5856,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1957,
    lifeExp: 61.448,
    pop: 442829,
    gdpPercap: 3682.2599,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1962,
    lifeExp: 63.728,
    pop: 474528,
    gdpPercap: 4649.5938,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1967,
    lifeExp: 67.178,
    pop: 501035,
    gdpPercap: 5907.8509,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1972,
    lifeExp: 70.636,
    pop: 527678,
    gdpPercap: 7778.414,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1977,
    lifeExp: 73.066,
    pop: 560073,
    gdpPercap: 9595.9299,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1982,
    lifeExp: 74.101,
    pop: 562548,
    gdpPercap: 11222.5876,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1987,
    lifeExp: 74.865,
    pop: 569473,
    gdpPercap: 11732.5102,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1992,
    lifeExp: 75.435,
    pop: 621621,
    gdpPercap: 7003.339,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 1997,
    lifeExp: 75.445,
    pop: 692651,
    gdpPercap: 6465.6133,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 2002,
    lifeExp: 73.981,
    pop: 720230,
    gdpPercap: 6557.1943,
  },
  {
    country: 'Montenegro',
    continent: 'Europe',
    year: 2007,
    lifeExp: 74.543,
    pop: 684736,
    gdpPercap: 9253.8961,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1952,
    lifeExp: 42.873,
    pop: 9939217,
    gdpPercap: 1688.2036,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1957,
    lifeExp: 45.423,
    pop: 11406350,
    gdpPercap: 1642.0023,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1962,
    lifeExp: 47.924,
    pop: 13056604,
    gdpPercap: 1566.3535,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1967,
    lifeExp: 50.335,
    pop: 14770296,
    gdpPercap: 1711.0448,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1972,
    lifeExp: 52.862,
    pop: 16660670,
    gdpPercap: 1930.195,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1977,
    lifeExp: 55.73,
    pop: 18396941,
    gdpPercap: 2370.62,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1982,
    lifeExp: 59.65,
    pop: 20198730,
    gdpPercap: 2702.6204,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1987,
    lifeExp: 62.677,
    pop: 22987397,
    gdpPercap: 2755.047,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1992,
    lifeExp: 65.393,
    pop: 25798239,
    gdpPercap: 2948.0473,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 1997,
    lifeExp: 67.66,
    pop: 28529501,
    gdpPercap: 2982.1019,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 2002,
    lifeExp: 69.615,
    pop: 31167783,
    gdpPercap: 3258.4956,
  },
  {
    country: 'Morocco',
    continent: 'Africa',
    year: 2007,
    lifeExp: 71.164,
    pop: 33757175,
    gdpPercap: 3820.1752,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1952,
    lifeExp: 31.286,
    pop: 6446316,
    gdpPercap: 468.526,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1957,
    lifeExp: 33.779,
    pop: 7038035,
    gdpPercap: 495.5868,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1962,
    lifeExp: 36.161,
    pop: 7788944,
    gdpPercap: 556.6864,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1967,
    lifeExp: 38.113,
    pop: 8680909,
    gdpPercap: 566.6692,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1972,
    lifeExp: 40.328,
    pop: 9809596,
    gdpPercap: 724.9178,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1977,
    lifeExp: 42.495,
    pop: 11127868,
    gdpPercap: 502.3197,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1982,
    lifeExp: 42.795,
    pop: 12587223,
    gdpPercap: 462.2114,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1987,
    lifeExp: 42.861,
    pop: 12891952,
    gdpPercap: 389.8762,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1992,
    lifeExp: 44.284,
    pop: 13160731,
    gdpPercap: 410.8968,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 1997,
    lifeExp: 46.344,
    pop: 16603334,
    gdpPercap: 472.3461,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 2002,
    lifeExp: 44.026,
    pop: 18473780,
    gdpPercap: 633.6179,
  },
  {
    country: 'Mozambique',
    continent: 'Africa',
    year: 2007,
    lifeExp: 42.082,
    pop: 19951656,
    gdpPercap: 823.6856,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1952,
    lifeExp: 36.319,
    pop: 20092996,
    gdpPercap: 331,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1957,
    lifeExp: 41.905,
    pop: 21731844,
    gdpPercap: 350,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1962,
    lifeExp: 45.108,
    pop: 23634436,
    gdpPercap: 388,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1967,
    lifeExp: 49.379,
    pop: 25870271,
    gdpPercap: 349,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1972,
    lifeExp: 53.07,
    pop: 28466390,
    gdpPercap: 357,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1977,
    lifeExp: 56.059,
    pop: 31528087,
    gdpPercap: 371,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1982,
    lifeExp: 58.056,
    pop: 34680442,
    gdpPercap: 424,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1987,
    lifeExp: 58.339,
    pop: 38028578,
    gdpPercap: 385,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1992,
    lifeExp: 59.32,
    pop: 40546538,
    gdpPercap: 347,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 1997,
    lifeExp: 60.328,
    pop: 43247867,
    gdpPercap: 415,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 2002,
    lifeExp: 59.908,
    pop: 45598081,
    gdpPercap: 611,
  },
  {
    country: 'Myanmar',
    continent: 'Asia',
    year: 2007,
    lifeExp: 62.069,
    pop: 47761980,
    gdpPercap: 944,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1952,
    lifeExp: 41.725,
    pop: 485831,
    gdpPercap: 2423.7804,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1957,
    lifeExp: 45.226,
    pop: 548080,
    gdpPercap: 2621.4481,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1962,
    lifeExp: 48.386,
    pop: 621392,
    gdpPercap: 3173.2156,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1967,
    lifeExp: 51.159,
    pop: 706640,
    gdpPercap: 3793.6948,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1972,
    lifeExp: 53.867,
    pop: 821782,
    gdpPercap: 3746.0809,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1977,
    lifeExp: 56.437,
    pop: 977026,
    gdpPercap: 3876.486,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1982,
    lifeExp: 58.968,
    pop: 1099010,
    gdpPercap: 4191.1005,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1987,
    lifeExp: 60.835,
    pop: 1278184,
    gdpPercap: 3693.7313,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1992,
    lifeExp: 61.999,
    pop: 1554253,
    gdpPercap: 3804.538,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 1997,
    lifeExp: 58.909,
    pop: 1774766,
    gdpPercap: 3899.5243,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 2002,
    lifeExp: 51.479,
    pop: 1972153,
    gdpPercap: 4072.3248,
  },
  {
    country: 'Namibia',
    continent: 'Africa',
    year: 2007,
    lifeExp: 52.906,
    pop: 2055080,
    gdpPercap: 4811.0604,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1952,
    lifeExp: 36.157,
    pop: 9182536,
    gdpPercap: 545.8657,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1957,
    lifeExp: 37.686,
    pop: 9682338,
    gdpPercap: 597.9364,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1962,
    lifeExp: 39.393,
    pop: 10332057,
    gdpPercap: 652.3969,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1967,
    lifeExp: 41.472,
    pop: 11261690,
    gdpPercap: 676.4422,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1972,
    lifeExp: 43.971,
    pop: 12412593,
    gdpPercap: 674.7881,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1977,
    lifeExp: 46.748,
    pop: 13933198,
    gdpPercap: 694.1124,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1982,
    lifeExp: 49.594,
    pop: 15796314,
    gdpPercap: 718.3731,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1987,
    lifeExp: 52.537,
    pop: 17917180,
    gdpPercap: 775.6325,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1992,
    lifeExp: 55.727,
    pop: 20326209,
    gdpPercap: 897.7404,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 1997,
    lifeExp: 59.426,
    pop: 23001113,
    gdpPercap: 1010.8921,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 2002,
    lifeExp: 61.34,
    pop: 25873917,
    gdpPercap: 1057.2063,
  },
  {
    country: 'Nepal',
    continent: 'Asia',
    year: 2007,
    lifeExp: 63.785,
    pop: 28901790,
    gdpPercap: 1091.3598,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1952,
    lifeExp: 72.13,
    pop: 10381988,
    gdpPercap: 8941.5719,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1957,
    lifeExp: 72.99,
    pop: 11026383,
    gdpPercap: 11276.1934,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1962,
    lifeExp: 73.23,
    pop: 11805689,
    gdpPercap: 12790.8496,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1967,
    lifeExp: 73.82,
    pop: 12596822,
    gdpPercap: 15363.2514,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1972,
    lifeExp: 73.75,
    pop: 13329874,
    gdpPercap: 18794.7457,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1977,
    lifeExp: 75.24,
    pop: 13852989,
    gdpPercap: 21209.0592,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1982,
    lifeExp: 76.05,
    pop: 14310401,
    gdpPercap: 21399.4605,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1987,
    lifeExp: 76.83,
    pop: 14665278,
    gdpPercap: 23651.3236,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1992,
    lifeExp: 77.42,
    pop: 15174244,
    gdpPercap: 26790.9496,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 1997,
    lifeExp: 78.03,
    pop: 15604464,
    gdpPercap: 30246.1306,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 2002,
    lifeExp: 78.53,
    pop: 16122830,
    gdpPercap: 33724.7578,
  },
  {
    country: 'Netherlands',
    continent: 'Europe',
    year: 2007,
    lifeExp: 79.762,
    pop: 16570613,
    gdpPercap: 36797.9333,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1952,
    lifeExp: 69.39,
    pop: 1994794,
    gdpPercap: 10556.5757,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1957,
    lifeExp: 70.26,
    pop: 2229407,
    gdpPercap: 12247.3953,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1962,
    lifeExp: 71.24,
    pop: 2488550,
    gdpPercap: 13175.678,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1967,
    lifeExp: 71.52,
    pop: 2728150,
    gdpPercap: 14463.9189,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1972,
    lifeExp: 71.89,
    pop: 2929100,
    gdpPercap: 16046.0373,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1977,
    lifeExp: 72.22,
    pop: 3164900,
    gdpPercap: 16233.7177,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1982,
    lifeExp: 73.84,
    pop: 3210650,
    gdpPercap: 17632.4104,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1987,
    lifeExp: 74.32,
    pop: 3317166,
    gdpPercap: 19007.1913,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1992,
    lifeExp: 76.33,
    pop: 3437674,
    gdpPercap: 18363.3249,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 1997,
    lifeExp: 77.55,
    pop: 3676187,
    gdpPercap: 21050.4138,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 2002,
    lifeExp: 79.11,
    pop: 3908037,
    gdpPercap: 23189.8014,
  },
  {
    country: 'New Zealand',
    continent: 'Oceania',
    year: 2007,
    lifeExp: 80.204,
    pop: 4115771,
    gdpPercap: 25185.0091,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1952,
    lifeExp: 42.314,
    pop: 1165790,
    gdpPercap: 3112.3639,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1957,
    lifeExp: 45.432,
    pop: 1358828,
    gdpPercap: 3457.4159,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1962,
    lifeExp: 48.632,
    pop: 1590597,
    gdpPercap: 3634.3644,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1967,
    lifeExp: 51.884,
    pop: 1865490,
    gdpPercap: 4643.3935,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1972,
    lifeExp: 55.151,
    pop: 2182908,
    gdpPercap: 4688.5933,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1977,
    lifeExp: 57.47,
    pop: 2554598,
    gdpPercap: 5486.3711,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1982,
    lifeExp: 59.298,
    pop: 2979423,
    gdpPercap: 3470.3382,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1987,
    lifeExp: 62.008,
    pop: 3344353,
    gdpPercap: 2955.9844,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1992,
    lifeExp: 65.843,
    pop: 4017939,
    gdpPercap: 2170.1517,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 1997,
    lifeExp: 68.426,
    pop: 4609572,
    gdpPercap: 2253.023,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 2002,
    lifeExp: 70.836,
    pop: 5146848,
    gdpPercap: 2474.5488,
  },
  {
    country: 'Nicaragua',
    continent: 'Americas',
    year: 2007,
    lifeExp: 72.899,
    pop: 5675356,
    gdpPercap: 2749.321,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1952,
    lifeExp: 37.444,
    pop: 3379468,
    gdpPercap: 761.8794,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1957,
    lifeExp: 38.598,
    pop: 3692184,
    gdpPercap: 835.5234,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1962,
    lifeExp: 39.487,
    pop: 4076008,
    gdpPercap: 997.7661,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1967,
    lifeExp: 40.118,
    pop: 4534062,
    gdpPercap: 1054.3849,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1972,
    lifeExp: 40.546,
    pop: 5060262,
    gdpPercap: 954.2092,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1977,
    lifeExp: 41.291,
    pop: 5682086,
    gdpPercap: 808.8971,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1982,
    lifeExp: 42.598,
    pop: 6437188,
    gdpPercap: 909.7221,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1987,
    lifeExp: 44.555,
    pop: 7332638,
    gdpPercap: 668.3,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1992,
    lifeExp: 47.391,
    pop: 8392818,
    gdpPercap: 581.1827,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 1997,
    lifeExp: 51.313,
    pop: 9666252,
    gdpPercap: 580.3052,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 2002,
    lifeExp: 54.496,
    pop: 11140655,
    gdpPercap: 601.0745,
  },
  {
    country: 'Niger',
    continent: 'Africa',
    year: 2007,
    lifeExp: 56.867,
    pop: 12894865,
    gdpPercap: 619.6769,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1952,
    lifeExp: 36.324,
    pop: 33119096,
    gdpPercap: 1077.2819,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1957,
    lifeExp: 37.802,
    pop: 37173340,
    gdpPercap: 1100.5926,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1962,
    lifeExp: 39.36,
    pop: 41871351,
    gdpPercap: 1150.9275,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1967,
    lifeExp: 41.04,
    pop: 47287752,
    gdpPercap: 1014.5141,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1972,
    lifeExp: 42.821,
    pop: 53740085,
    gdpPercap: 1698.3888,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1977,
    lifeExp: 44.514,
    pop: 62209173,
    gdpPercap: 1981.9518,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1982,
    lifeExp: 45.826,
    pop: 73039376,
    gdpPercap: 1576.9738,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1987,
    lifeExp: 46.886,
    pop: 81551520,
    gdpPercap: 1385.0296,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1992,
    lifeExp: 47.472,
    pop: 93364244,
    gdpPercap: 1619.8482,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 1997,
    lifeExp: 47.464,
    pop: 106207839,
    gdpPercap: 1624.9413,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 2002,
    lifeExp: 46.608,
    pop: 119901274,
    gdpPercap: 1615.2864,
  },
  {
    country: 'Nigeria',
    continent: 'Africa',
    year: 2007,
    lifeExp: 46.859,
    pop: 135031164,
    gdpPercap: 2013.9773,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1952,
    lifeExp: 72.67,
    pop: 3327728,
    gdpPercap: 10095.4217,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1957,
    lifeExp: 73.44,
    pop: 3491938,
    gdpPercap: 11653.973,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1962,
    lifeExp: 73.47,
    pop: 3638919,
    gdpPercap: 13450.4015,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1967,
    lifeExp: 74.08,
    pop: 3786019,
    gdpPercap: 16361.8765,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1972,
    lifeExp: 74.34,
    pop: 3933004,
    gdpPercap: 18965.0555,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1977,
    lifeExp: 75.37,
    pop: 4043205,
    gdpPercap: 23311.3494,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1982,
    lifeExp: 75.97,
    pop: 4114787,
    gdpPercap: 26298.6353,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1987,
    lifeExp: 75.89,
    pop: 4186147,
    gdpPercap: 31540.9748,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1992,
    lifeExp: 77.32,
    pop: 4286357,
    gdpPercap: 33965.6611,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 1997,
    lifeExp: 78.32,
    pop: 4405672,
    gdpPercap: 41283.1643,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 2002,
    lifeExp: 79.05,
    pop: 4535591,
    gdpPercap: 44683.9753,
  },
  {
    country: 'Norway',
    continent: 'Europe',
    year: 2007,
    lifeExp: 80.196,
    pop: 4627926,
    gdpPercap: 49357.1902,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1952,
    lifeExp: 37.578,
    pop: 507833,
    gdpPercap: 1828.2303,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1957,
    lifeExp: 40.08,
    pop: 561977,
    gdpPercap: 2242.7466,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1962,
    lifeExp: 43.165,
    pop: 628164,
    gdpPercap: 2924.6381,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1967,
    lifeExp: 46.988,
    pop: 714775,
    gdpPercap: 4720.9427,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1972,
    lifeExp: 52.143,
    pop: 829050,
    gdpPercap: 10618.0385,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1977,
    lifeExp: 57.367,
    pop: 1004533,
    gdpPercap: 11848.3439,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1982,
    lifeExp: 62.728,
    pop: 1301048,
    gdpPercap: 12954.791,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1987,
    lifeExp: 67.734,
    pop: 1593882,
    gdpPercap: 18115.2231,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1992,
    lifeExp: 71.197,
    pop: 1915208,
    gdpPercap: 18616.7069,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 1997,
    lifeExp: 72.499,
    pop: 2283635,
    gdpPercap: 19702.0558,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 2002,
    lifeExp: 74.193,
    pop: 2713462,
    gdpPercap: 19774.8369,
  },
  {
    country: 'Oman',
    continent: 'Asia',
    year: 2007,
    lifeExp: 75.64,
    pop: 3204897,
    gdpPercap: 22316.1929,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1952,
    lifeExp: 43.436,
    pop: 41346560,
    gdpPercap: 684.5971,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1957,
    lifeExp: 45.557,
    pop: 46679944,
    gdpPercap: 747.0835,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1962,
    lifeExp: 47.67,
    pop: 53100671,
    gdpPercap: 803.3427,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1967,
    lifeExp: 49.8,
    pop: 60641899,
    gdpPercap: 942.4083,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1972,
    lifeExp: 51.929,
    pop: 69325921,
    gdpPercap: 1049.939,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1977,
    lifeExp: 54.043,
    pop: 78152686,
    gdpPercap: 1175.9212,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1982,
    lifeExp: 56.158,
    pop: 91462088,
    gdpPercap: 1443.4298,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1987,
    lifeExp: 58.245,
    pop: 105186881,
    gdpPercap: 1704.6866,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1992,
    lifeExp: 60.838,
    pop: 120065004,
    gdpPercap: 1971.8295,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 1997,
    lifeExp: 61.818,
    pop: 135564834,
    gdpPercap: 2049.3505,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 2002,
    lifeExp: 63.61,
    pop: 153403524,
    gdpPercap: 2092.7124,
  },
  {
    country: 'Pakistan',
    continent: 'Asia',
    year: 2007,
    lifeExp: 65.483,
    pop: 169270617,
    gdpPercap: 2605.9476,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1952,
    lifeExp: 55.191,
    pop: 940080,
    gdpPercap: 2480.3803,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1957,
    lifeExp: 59.201,
    pop: 1063506,
    gdpPercap: 2961.8009,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1962,
    lifeExp: 61.817,
    pop: 1215725,
    gdpPercap: 3536.5403,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1967,
    lifeExp: 64.071,
    pop: 1405486,
    gdpPercap: 4421.0091,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1972,
    lifeExp: 66.216,
    pop: 1616384,
    gdpPercap: 5364.2497,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1977,
    lifeExp: 68.681,
    pop: 1839782,
    gdpPercap: 5351.9121,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1982,
    lifeExp: 70.472,
    pop: 2036305,
    gdpPercap: 7009.6016,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1987,
    lifeExp: 71.523,
    pop: 2253639,
    gdpPercap: 7034.7792,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1992,
    lifeExp: 72.462,
    pop: 2484997,
    gdpPercap: 6618.7431,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 1997,
    lifeExp: 73.738,
    pop: 2734531,
    gdpPercap: 7113.6923,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 2002,
    lifeExp: 74.712,
    pop: 2990875,
    gdpPercap: 7356.0319,
  },
  {
    country: 'Panama',
    continent: 'Americas',
    year: 2007,
    lifeExp: 75.537,
    pop: 3242173,
    gdpPercap: 9809.1856,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1952,
    lifeExp: 62.649,
    pop: 1555876,
    gdpPercap: 1952.3087,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1957,
    lifeExp: 63.196,
    pop: 1770902,
    gdpPercap: 2046.1547,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1962,
    lifeExp: 64.361,
    pop: 2009813,
    gdpPercap: 2148.0271,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1967,
    lifeExp: 64.951,
    pop: 2287985,
    gdpPercap: 2299.3763,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1972,
    lifeExp: 65.815,
    pop: 2614104,
    gdpPercap: 2523.338,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1977,
    lifeExp: 66.353,
    pop: 2984494,
    gdpPercap: 3248.3733,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1982,
    lifeExp: 66.874,
    pop: 3366439,
    gdpPercap: 4258.5036,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1987,
    lifeExp: 67.378,
    pop: 3886512,
    gdpPercap: 3998.8757,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1992,
    lifeExp: 68.225,
    pop: 4483945,
    gdpPercap: 4196.4111,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 1997,
    lifeExp: 69.4,
    pop: 5154123,
    gdpPercap: 4247.4003,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 2002,
    lifeExp: 70.755,
    pop: 5884491,
    gdpPercap: 3783.6742,
  },
  {
    country: 'Paraguay',
    continent: 'Americas',
    year: 2007,
    lifeExp: 71.752,
    pop: 6667147,
    gdpPercap: 4172.8385,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1952,
    lifeExp: 43.902,
    pop: 8025700,
    gdpPercap: 3758.5234,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1957,
    lifeExp: 46.263,
    pop: 9146100,
    gdpPercap: 4245.2567,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1962,
    lifeExp: 49.096,
    pop: 10516500,
    gdpPercap: 4957.038,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1967,
    lifeExp: 51.445,
    pop: 12132200,
    gdpPercap: 5788.0933,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1972,
    lifeExp: 55.448,
    pop: 13954700,
    gdpPercap: 5937.8273,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1977,
    lifeExp: 58.447,
    pop: 15990099,
    gdpPercap: 6281.2909,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1982,
    lifeExp: 61.406,
    pop: 18125129,
    gdpPercap: 6434.5018,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1987,
    lifeExp: 64.134,
    pop: 20195924,
    gdpPercap: 6360.9434,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1992,
    lifeExp: 66.458,
    pop: 22430449,
    gdpPercap: 4446.3809,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 1997,
    lifeExp: 68.386,
    pop: 24748122,
    gdpPercap: 5838.3477,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 2002,
    lifeExp: 69.906,
    pop: 26769436,
    gdpPercap: 5909.0201,
  },
  {
    country: 'Peru',
    continent: 'Americas',
    year: 2007,
    lifeExp: 71.421,
    pop: 28674757,
    gdpPercap: 7408.9056,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1952,
    lifeExp: 47.752,
    pop: 22438691,
    gdpPercap: 1272.881,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1957,
    lifeExp: 51.334,
    pop: 26072194,
    gdpPercap: 1547.9448,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1962,
    lifeExp: 54.757,
    pop: 30325264,
    gdpPercap: 1649.5522,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1967,
    lifeExp: 56.393,
    pop: 35356600,
    gdpPercap: 1814.1274,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1972,
    lifeExp: 58.065,
    pop: 40850141,
    gdpPercap: 1989.3741,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1977,
    lifeExp: 60.06,
    pop: 46850962,
    gdpPercap: 2373.2043,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1982,
    lifeExp: 62.082,
    pop: 53456774,
    gdpPercap: 2603.2738,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1987,
    lifeExp: 64.151,
    pop: 60017788,
    gdpPercap: 2189.635,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1992,
    lifeExp: 66.458,
    pop: 67185766,
    gdpPercap: 2279.324,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 1997,
    lifeExp: 68.564,
    pop: 75012988,
    gdpPercap: 2536.5349,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 2002,
    lifeExp: 70.303,
    pop: 82995088,
    gdpPercap: 2650.9211,
  },
  {
    country: 'Philippines',
    continent: 'Asia',
    year: 2007,
    lifeExp: 71.688,
    pop: 91077287,
    gdpPercap: 3190.481,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1952,
    lifeExp: 61.31,
    pop: 25730551,
    gdpPercap: 4029.3297,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1957,
    lifeExp: 65.77,
    pop: 28235346,
    gdpPercap: 4734.253,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1962,
    lifeExp: 67.64,
    pop: 30329617,
    gdpPercap: 5338.7521,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1967,
    lifeExp: 69.61,
    pop: 31785378,
    gdpPercap: 6557.1528,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1972,
    lifeExp: 70.85,
    pop: 33039545,
    gdpPercap: 8006.507,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.67,
    pop: 34621254,
    gdpPercap: 9508.1415,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1982,
    lifeExp: 71.32,
    pop: 36227381,
    gdpPercap: 8451.531,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1987,
    lifeExp: 70.98,
    pop: 37740710,
    gdpPercap: 9082.3512,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1992,
    lifeExp: 70.99,
    pop: 38370697,
    gdpPercap: 7738.8812,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 1997,
    lifeExp: 72.75,
    pop: 38654957,
    gdpPercap: 10159.5837,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 2002,
    lifeExp: 74.67,
    pop: 38625976,
    gdpPercap: 12002.2391,
  },
  {
    country: 'Poland',
    continent: 'Europe',
    year: 2007,
    lifeExp: 75.563,
    pop: 38518241,
    gdpPercap: 15389.9247,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1952,
    lifeExp: 59.82,
    pop: 8526050,
    gdpPercap: 3068.3199,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1957,
    lifeExp: 61.51,
    pop: 8817650,
    gdpPercap: 3774.5717,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1962,
    lifeExp: 64.39,
    pop: 9019800,
    gdpPercap: 4727.9549,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1967,
    lifeExp: 66.6,
    pop: 9103000,
    gdpPercap: 6361.518,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1972,
    lifeExp: 69.26,
    pop: 8970450,
    gdpPercap: 9022.2474,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.41,
    pop: 9662600,
    gdpPercap: 10172.4857,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1982,
    lifeExp: 72.77,
    pop: 9859650,
    gdpPercap: 11753.8429,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1987,
    lifeExp: 74.06,
    pop: 9915289,
    gdpPercap: 13039.3088,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1992,
    lifeExp: 74.86,
    pop: 9927680,
    gdpPercap: 16207.2666,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 1997,
    lifeExp: 75.97,
    pop: 10156415,
    gdpPercap: 17641.0316,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 2002,
    lifeExp: 77.29,
    pop: 10433867,
    gdpPercap: 19970.9079,
  },
  {
    country: 'Portugal',
    continent: 'Europe',
    year: 2007,
    lifeExp: 78.098,
    pop: 10642836,
    gdpPercap: 20509.6478,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1952,
    lifeExp: 64.28,
    pop: 2227000,
    gdpPercap: 3081.9598,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1957,
    lifeExp: 68.54,
    pop: 2260000,
    gdpPercap: 3907.1562,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1962,
    lifeExp: 69.62,
    pop: 2448046,
    gdpPercap: 5108.3446,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1967,
    lifeExp: 71.1,
    pop: 2648961,
    gdpPercap: 6929.2777,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1972,
    lifeExp: 72.16,
    pop: 2847132,
    gdpPercap: 9123.0417,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1977,
    lifeExp: 73.44,
    pop: 3080828,
    gdpPercap: 9770.5249,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1982,
    lifeExp: 73.75,
    pop: 3279001,
    gdpPercap: 10330.9891,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1987,
    lifeExp: 74.63,
    pop: 3444468,
    gdpPercap: 12281.3419,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1992,
    lifeExp: 73.911,
    pop: 3585176,
    gdpPercap: 14641.5871,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 1997,
    lifeExp: 74.917,
    pop: 3759430,
    gdpPercap: 16999.4333,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 2002,
    lifeExp: 77.778,
    pop: 3859606,
    gdpPercap: 18855.6062,
  },
  {
    country: 'Puerto Rico',
    continent: 'Americas',
    year: 2007,
    lifeExp: 78.746,
    pop: 3942491,
    gdpPercap: 19328.709,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1952,
    lifeExp: 52.724,
    pop: 257700,
    gdpPercap: 2718.8853,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1957,
    lifeExp: 55.09,
    pop: 308700,
    gdpPercap: 2769.4518,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1962,
    lifeExp: 57.666,
    pop: 358900,
    gdpPercap: 3173.7233,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1967,
    lifeExp: 60.542,
    pop: 414024,
    gdpPercap: 4021.1757,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1972,
    lifeExp: 64.274,
    pop: 461633,
    gdpPercap: 5047.6586,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1977,
    lifeExp: 67.064,
    pop: 492095,
    gdpPercap: 4319.8041,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1982,
    lifeExp: 69.885,
    pop: 517810,
    gdpPercap: 5267.2194,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1987,
    lifeExp: 71.913,
    pop: 562035,
    gdpPercap: 5303.3775,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1992,
    lifeExp: 73.615,
    pop: 622191,
    gdpPercap: 6101.2558,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 1997,
    lifeExp: 74.772,
    pop: 684810,
    gdpPercap: 6071.9414,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 2002,
    lifeExp: 75.744,
    pop: 743981,
    gdpPercap: 6316.1652,
  },
  {
    country: 'Reunion',
    continent: 'Africa',
    year: 2007,
    lifeExp: 76.442,
    pop: 798094,
    gdpPercap: 7670.1226,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1952,
    lifeExp: 61.05,
    pop: 16630000,
    gdpPercap: 3144.6132,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1957,
    lifeExp: 64.1,
    pop: 17829327,
    gdpPercap: 3943.3702,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1962,
    lifeExp: 66.8,
    pop: 18680721,
    gdpPercap: 4734.9976,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1967,
    lifeExp: 66.8,
    pop: 19284814,
    gdpPercap: 6470.8665,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1972,
    lifeExp: 69.21,
    pop: 20662648,
    gdpPercap: 8011.4144,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1977,
    lifeExp: 69.46,
    pop: 21658597,
    gdpPercap: 9356.3972,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1982,
    lifeExp: 69.66,
    pop: 22356726,
    gdpPercap: 9605.3141,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1987,
    lifeExp: 69.53,
    pop: 22686371,
    gdpPercap: 9696.2733,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1992,
    lifeExp: 69.36,
    pop: 22797027,
    gdpPercap: 6598.4099,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 1997,
    lifeExp: 69.72,
    pop: 22562458,
    gdpPercap: 7346.5476,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 2002,
    lifeExp: 71.322,
    pop: 22404337,
    gdpPercap: 7885.3601,
  },
  {
    country: 'Romania',
    continent: 'Europe',
    year: 2007,
    lifeExp: 72.476,
    pop: 22276056,
    gdpPercap: 10808.4756,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1952,
    lifeExp: 40,
    pop: 2534927,
    gdpPercap: 493.3239,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1957,
    lifeExp: 41.5,
    pop: 2822082,
    gdpPercap: 540.2894,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1962,
    lifeExp: 43,
    pop: 3051242,
    gdpPercap: 597.4731,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1967,
    lifeExp: 44.1,
    pop: 3451079,
    gdpPercap: 510.9637,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1972,
    lifeExp: 44.6,
    pop: 3992121,
    gdpPercap: 590.5807,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1977,
    lifeExp: 45,
    pop: 4657072,
    gdpPercap: 670.0806,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1982,
    lifeExp: 46.218,
    pop: 5507565,
    gdpPercap: 881.5706,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1987,
    lifeExp: 44.02,
    pop: 6349365,
    gdpPercap: 847.9912,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1992,
    lifeExp: 23.599,
    pop: 7290203,
    gdpPercap: 737.0686,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 1997,
    lifeExp: 36.087,
    pop: 7212583,
    gdpPercap: 589.9445,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 2002,
    lifeExp: 43.413,
    pop: 7852401,
    gdpPercap: 785.6538,
  },
  {
    country: 'Rwanda',
    continent: 'Africa',
    year: 2007,
    lifeExp: 46.242,
    pop: 8860588,
    gdpPercap: 863.0885,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1952,
    lifeExp: 46.471,
    pop: 60011,
    gdpPercap: 879.5836,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1957,
    lifeExp: 48.945,
    pop: 61325,
    gdpPercap: 860.7369,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1962,
    lifeExp: 51.893,
    pop: 65345,
    gdpPercap: 1071.5511,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1967,
    lifeExp: 54.425,
    pop: 70787,
    gdpPercap: 1384.8406,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1972,
    lifeExp: 56.48,
    pop: 76595,
    gdpPercap: 1532.9853,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1977,
    lifeExp: 58.55,
    pop: 86796,
    gdpPercap: 1737.5617,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1982,
    lifeExp: 60.351,
    pop: 98593,
    gdpPercap: 1890.2181,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1987,
    lifeExp: 61.728,
    pop: 110812,
    gdpPercap: 1516.5255,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1992,
    lifeExp: 62.742,
    pop: 125911,
    gdpPercap: 1428.7778,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 1997,
    lifeExp: 63.306,
    pop: 145608,
    gdpPercap: 1339.076,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 2002,
    lifeExp: 64.337,
    pop: 170372,
    gdpPercap: 1353.0924,
  },
  {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    year: 2007,
    lifeExp: 65.528,
    pop: 199579,
    gdpPercap: 1598.4351,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1952,
    lifeExp: 39.875,
    pop: 4005677,
    gdpPercap: 6459.5548,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1957,
    lifeExp: 42.868,
    pop: 4419650,
    gdpPercap: 8157.5912,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1962,
    lifeExp: 45.914,
    pop: 4943029,
    gdpPercap: 11626.4197,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1967,
    lifeExp: 49.901,
    pop: 5618198,
    gdpPercap: 16903.0489,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1972,
    lifeExp: 53.886,
    pop: 6472756,
    gdpPercap: 24837.4287,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1977,
    lifeExp: 58.69,
    pop: 8128505,
    gdpPercap: 34167.7626,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1982,
    lifeExp: 63.012,
    pop: 11254672,
    gdpPercap: 33693.1753,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1987,
    lifeExp: 66.295,
    pop: 14619745,
    gdpPercap: 21198.2614,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1992,
    lifeExp: 68.768,
    pop: 16945857,
    gdpPercap: 24841.6178,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 1997,
    lifeExp: 70.533,
    pop: 21229759,
    gdpPercap: 20586.6902,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 2002,
    lifeExp: 71.626,
    pop: 24501530,
    gdpPercap: 19014.5412,
  },
  {
    country: 'Saudi Arabia',
    continent: 'Asia',
    year: 2007,
    lifeExp: 72.777,
    pop: 27601038,
    gdpPercap: 21654.8319,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1952,
    lifeExp: 37.278,
    pop: 2755589,
    gdpPercap: 1450.357,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1957,
    lifeExp: 39.329,
    pop: 3054547,
    gdpPercap: 1567.653,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1962,
    lifeExp: 41.454,
    pop: 3430243,
    gdpPercap: 1654.9887,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1967,
    lifeExp: 43.563,
    pop: 3965841,
    gdpPercap: 1612.4046,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1972,
    lifeExp: 45.815,
    pop: 4588696,
    gdpPercap: 1597.7121,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1977,
    lifeExp: 48.879,
    pop: 5260855,
    gdpPercap: 1561.7691,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1982,
    lifeExp: 52.379,
    pop: 6147783,
    gdpPercap: 1518.48,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1987,
    lifeExp: 55.769,
    pop: 7171347,
    gdpPercap: 1441.7207,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1992,
    lifeExp: 58.196,
    pop: 8307920,
    gdpPercap: 1367.8994,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 1997,
    lifeExp: 60.187,
    pop: 9535314,
    gdpPercap: 1392.3683,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 2002,
    lifeExp: 61.6,
    pop: 10870037,
    gdpPercap: 1519.6353,
  },
  {
    country: 'Senegal',
    continent: 'Africa',
    year: 2007,
    lifeExp: 63.062,
    pop: 12267493,
    gdpPercap: 1712.4721,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1952,
    lifeExp: 57.996,
    pop: 6860147,
    gdpPercap: 3581.4594,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1957,
    lifeExp: 61.685,
    pop: 7271135,
    gdpPercap: 4981.0909,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1962,
    lifeExp: 64.531,
    pop: 7616060,
    gdpPercap: 6289.6292,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1967,
    lifeExp: 66.914,
    pop: 7971222,
    gdpPercap: 7991.7071,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1972,
    lifeExp: 68.7,
    pop: 8313288,
    gdpPercap: 10522.0675,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.3,
    pop: 8686367,
    gdpPercap: 12980.6696,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1982,
    lifeExp: 70.162,
    pop: 9032824,
    gdpPercap: 15181.0927,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1987,
    lifeExp: 71.218,
    pop: 9230783,
    gdpPercap: 15870.8785,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1992,
    lifeExp: 71.659,
    pop: 9826397,
    gdpPercap: 9325.0682,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 1997,
    lifeExp: 72.232,
    pop: 10336594,
    gdpPercap: 7914.3203,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 2002,
    lifeExp: 73.213,
    pop: 10111559,
    gdpPercap: 7236.0753,
  },
  {
    country: 'Serbia',
    continent: 'Europe',
    year: 2007,
    lifeExp: 74.002,
    pop: 10150265,
    gdpPercap: 9786.5347,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1952,
    lifeExp: 30.331,
    pop: 2143249,
    gdpPercap: 879.7877,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1957,
    lifeExp: 31.57,
    pop: 2295678,
    gdpPercap: 1004.4844,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1962,
    lifeExp: 32.767,
    pop: 2467895,
    gdpPercap: 1116.6399,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1967,
    lifeExp: 34.113,
    pop: 2662190,
    gdpPercap: 1206.0435,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1972,
    lifeExp: 35.4,
    pop: 2879013,
    gdpPercap: 1353.7598,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1977,
    lifeExp: 36.788,
    pop: 3140897,
    gdpPercap: 1348.2852,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1982,
    lifeExp: 38.445,
    pop: 3464522,
    gdpPercap: 1465.0108,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1987,
    lifeExp: 40.006,
    pop: 3868905,
    gdpPercap: 1294.4478,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1992,
    lifeExp: 38.333,
    pop: 4260884,
    gdpPercap: 1068.6963,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 1997,
    lifeExp: 39.897,
    pop: 4578212,
    gdpPercap: 574.6482,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 2002,
    lifeExp: 41.012,
    pop: 5359092,
    gdpPercap: 699.4897,
  },
  {
    country: 'Sierra Leone',
    continent: 'Africa',
    year: 2007,
    lifeExp: 42.568,
    pop: 6144562,
    gdpPercap: 862.5408,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1952,
    lifeExp: 60.396,
    pop: 1127000,
    gdpPercap: 2315.1382,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1957,
    lifeExp: 63.179,
    pop: 1445929,
    gdpPercap: 2843.1044,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1962,
    lifeExp: 65.798,
    pop: 1750200,
    gdpPercap: 3674.7356,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1967,
    lifeExp: 67.946,
    pop: 1977600,
    gdpPercap: 4977.4185,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1972,
    lifeExp: 69.521,
    pop: 2152400,
    gdpPercap: 8597.7562,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1977,
    lifeExp: 70.795,
    pop: 2325300,
    gdpPercap: 11210.0895,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1982,
    lifeExp: 71.76,
    pop: 2651869,
    gdpPercap: 15169.1611,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1987,
    lifeExp: 73.56,
    pop: 2794552,
    gdpPercap: 18861.5308,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1992,
    lifeExp: 75.788,
    pop: 3235865,
    gdpPercap: 24769.8912,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 1997,
    lifeExp: 77.158,
    pop: 3802309,
    gdpPercap: 33519.4766,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 2002,
    lifeExp: 78.77,
    pop: 4197776,
    gdpPercap: 36023.1054,
  },
  {
    country: 'Singapore',
    continent: 'Asia',
    year: 2007,
    lifeExp: 79.972,
    pop: 4553009,
    gdpPercap: 47143.1796,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1952,
    lifeExp: 64.36,
    pop: 3558137,
    gdpPercap: 5074.6591,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1957,
    lifeExp: 67.45,
    pop: 3844277,
    gdpPercap: 6093.263,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1962,
    lifeExp: 70.33,
    pop: 4237384,
    gdpPercap: 7481.1076,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1967,
    lifeExp: 70.98,
    pop: 4442238,
    gdpPercap: 8412.9024,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1972,
    lifeExp: 70.35,
    pop: 4593433,
    gdpPercap: 9674.1676,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.45,
    pop: 4827803,
    gdpPercap: 10922.664,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1982,
    lifeExp: 70.8,
    pop: 5048043,
    gdpPercap: 11348.5459,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1987,
    lifeExp: 71.08,
    pop: 5199318,
    gdpPercap: 12037.2676,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1992,
    lifeExp: 71.38,
    pop: 5302888,
    gdpPercap: 9498.4677,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 1997,
    lifeExp: 72.71,
    pop: 5383010,
    gdpPercap: 12126.2306,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 2002,
    lifeExp: 73.8,
    pop: 5410052,
    gdpPercap: 13638.7784,
  },
  {
    country: 'Slovak Republic',
    continent: 'Europe',
    year: 2007,
    lifeExp: 74.663,
    pop: 5447502,
    gdpPercap: 18678.3144,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1952,
    lifeExp: 65.57,
    pop: 1489518,
    gdpPercap: 4215.0417,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1957,
    lifeExp: 67.85,
    pop: 1533070,
    gdpPercap: 5862.2766,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1962,
    lifeExp: 69.15,
    pop: 1582962,
    gdpPercap: 7402.3034,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1967,
    lifeExp: 69.18,
    pop: 1646912,
    gdpPercap: 9405.4894,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1972,
    lifeExp: 69.82,
    pop: 1694510,
    gdpPercap: 12383.4862,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1977,
    lifeExp: 70.97,
    pop: 1746919,
    gdpPercap: 15277.0302,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1982,
    lifeExp: 71.063,
    pop: 1861252,
    gdpPercap: 17866.7218,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1987,
    lifeExp: 72.25,
    pop: 1945870,
    gdpPercap: 18678.5349,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1992,
    lifeExp: 73.64,
    pop: 1999210,
    gdpPercap: 14214.7168,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 1997,
    lifeExp: 75.13,
    pop: 2011612,
    gdpPercap: 17161.1073,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 2002,
    lifeExp: 76.66,
    pop: 2011497,
    gdpPercap: 20660.0194,
  },
  {
    country: 'Slovenia',
    continent: 'Europe',
    year: 2007,
    lifeExp: 77.926,
    pop: 2009245,
    gdpPercap: 25768.2576,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1952,
    lifeExp: 32.978,
    pop: 2526994,
    gdpPercap: 1135.7498,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1957,
    lifeExp: 34.977,
    pop: 2780415,
    gdpPercap: 1258.1474,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1962,
    lifeExp: 36.981,
    pop: 3080153,
    gdpPercap: 1369.4883,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1967,
    lifeExp: 38.977,
    pop: 3428839,
    gdpPercap: 1284.7332,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1972,
    lifeExp: 40.973,
    pop: 3840161,
    gdpPercap: 1254.5761,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1977,
    lifeExp: 41.974,
    pop: 4353666,
    gdpPercap: 1450.9925,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1982,
    lifeExp: 42.955,
    pop: 5828892,
    gdpPercap: 1176.807,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1987,
    lifeExp: 44.501,
    pop: 6921858,
    gdpPercap: 1093.245,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1992,
    lifeExp: 39.658,
    pop: 6099799,
    gdpPercap: 926.9603,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 1997,
    lifeExp: 43.795,
    pop: 6633514,
    gdpPercap: 930.5964,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 2002,
    lifeExp: 45.936,
    pop: 7753310,
    gdpPercap: 882.0818,
  },
  {
    country: 'Somalia',
    continent: 'Africa',
    year: 2007,
    lifeExp: 48.159,
    pop: 9118773,
    gdpPercap: 926.1411,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1952,
    lifeExp: 45.009,
    pop: 14264935,
    gdpPercap: 4725.2955,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1957,
    lifeExp: 47.985,
    pop: 16151549,
    gdpPercap: 5487.1042,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1962,
    lifeExp: 49.951,
    pop: 18356657,
    gdpPercap: 5768.7297,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1967,
    lifeExp: 51.927,
    pop: 20997321,
    gdpPercap: 7114.478,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1972,
    lifeExp: 53.696,
    pop: 23935810,
    gdpPercap: 7765.9626,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1977,
    lifeExp: 55.527,
    pop: 27129932,
    gdpPercap: 8028.6514,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1982,
    lifeExp: 58.161,
    pop: 31140029,
    gdpPercap: 8568.2662,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1987,
    lifeExp: 60.834,
    pop: 35933379,
    gdpPercap: 7825.8234,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1992,
    lifeExp: 61.888,
    pop: 39964159,
    gdpPercap: 7225.0693,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 1997,
    lifeExp: 60.236,
    pop: 42835005,
    gdpPercap: 7479.1882,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 2002,
    lifeExp: 53.365,
    pop: 44433622,
    gdpPercap: 7710.9464,
  },
  {
    country: 'South Africa',
    continent: 'Africa',
    year: 2007,
    lifeExp: 49.339,
    pop: 43997828,
    gdpPercap: 9269.6578,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1952,
    lifeExp: 64.94,
    pop: 28549870,
    gdpPercap: 3834.0347,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1957,
    lifeExp: 66.66,
    pop: 29841614,
    gdpPercap: 4564.8024,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1962,
    lifeExp: 69.69,
    pop: 31158061,
    gdpPercap: 5693.8439,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1967,
    lifeExp: 71.44,
    pop: 32850275,
    gdpPercap: 7993.5123,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1972,
    lifeExp: 73.06,
    pop: 34513161,
    gdpPercap: 10638.7513,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1977,
    lifeExp: 74.39,
    pop: 36439000,
    gdpPercap: 13236.9212,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1982,
    lifeExp: 76.3,
    pop: 37983310,
    gdpPercap: 13926.17,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1987,
    lifeExp: 76.9,
    pop: 38880702,
    gdpPercap: 15764.9831,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1992,
    lifeExp: 77.57,
    pop: 39549438,
    gdpPercap: 18603.0645,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 1997,
    lifeExp: 78.77,
    pop: 39855442,
    gdpPercap: 20445.299,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 2002,
    lifeExp: 79.78,
    pop: 40152517,
    gdpPercap: 24835.4717,
  },
  {
    country: 'Spain',
    continent: 'Europe',
    year: 2007,
    lifeExp: 80.941,
    pop: 40448191,
    gdpPercap: 28821.0637,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1952,
    lifeExp: 57.593,
    pop: 7982342,
    gdpPercap: 1083.532,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1957,
    lifeExp: 61.456,
    pop: 9128546,
    gdpPercap: 1072.5466,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1962,
    lifeExp: 62.192,
    pop: 10421936,
    gdpPercap: 1074.472,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1967,
    lifeExp: 64.266,
    pop: 11737396,
    gdpPercap: 1135.5143,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1972,
    lifeExp: 65.042,
    pop: 13016733,
    gdpPercap: 1213.3955,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1977,
    lifeExp: 65.949,
    pop: 14116836,
    gdpPercap: 1348.7757,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1982,
    lifeExp: 68.757,
    pop: 15410151,
    gdpPercap: 1648.0798,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1987,
    lifeExp: 69.011,
    pop: 16495304,
    gdpPercap: 1876.7668,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1992,
    lifeExp: 70.379,
    pop: 17587060,
    gdpPercap: 2153.7392,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 1997,
    lifeExp: 70.457,
    pop: 18698655,
    gdpPercap: 2664.4773,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 2002,
    lifeExp: 70.815,
    pop: 19576783,
    gdpPercap: 3015.3788,
  },
  {
    country: 'Sri Lanka',
    continent: 'Asia',
    year: 2007,
    lifeExp: 72.396,
    pop: 20378239,
    gdpPercap: 3970.0954,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1952,
    lifeExp: 38.635,
    pop: 8504667,
    gdpPercap: 1615.9911,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1957,
    lifeExp: 39.624,
    pop: 9753392,
    gdpPercap: 1770.3371,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1962,
    lifeExp: 40.87,
    pop: 11183227,
    gdpPercap: 1959.5938,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1967,
    lifeExp: 42.858,
    pop: 12716129,
    gdpPercap: 1687.9976,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1972,
    lifeExp: 45.083,
    pop: 14597019,
    gdpPercap: 1659.6528,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1977,
    lifeExp: 47.8,
    pop: 17104986,
    gdpPercap: 2202.9884,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1982,
    lifeExp: 50.338,
    pop: 20367053,
    gdpPercap: 1895.5441,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1987,
    lifeExp: 51.744,
    pop: 24725960,
    gdpPercap: 1507.8192,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1992,
    lifeExp: 53.556,
    pop: 28227588,
    gdpPercap: 1492.197,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 1997,
    lifeExp: 55.373,
    pop: 32160729,
    gdpPercap: 1632.2108,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 2002,
    lifeExp: 56.369,
    pop: 37090298,
    gdpPercap: 1993.3983,
  },
  {
    country: 'Sudan',
    continent: 'Africa',
    year: 2007,
    lifeExp: 58.556,
    pop: 42292929,
    gdpPercap: 2602.395,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1952,
    lifeExp: 41.407,
    pop: 290243,
    gdpPercap: 1148.3766,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1957,
    lifeExp: 43.424,
    pop: 326741,
    gdpPercap: 1244.7084,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1962,
    lifeExp: 44.992,
    pop: 370006,
    gdpPercap: 1856.1821,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1967,
    lifeExp: 46.633,
    pop: 420690,
    gdpPercap: 2613.1017,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1972,
    lifeExp: 49.552,
    pop: 480105,
    gdpPercap: 3364.8366,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1977,
    lifeExp: 52.537,
    pop: 551425,
    gdpPercap: 3781.4106,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1982,
    lifeExp: 55.561,
    pop: 649901,
    gdpPercap: 3895.384,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1987,
    lifeExp: 57.678,
    pop: 779348,
    gdpPercap: 3984.8398,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1992,
    lifeExp: 58.474,
    pop: 962344,
    gdpPercap: 3553.0224,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 1997,
    lifeExp: 54.289,
    pop: 1054486,
    gdpPercap: 3876.7685,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 2002,
    lifeExp: 43.869,
    pop: 1130269,
    gdpPercap: 4128.1169,
  },
  {
    country: 'Swaziland',
    continent: 'Africa',
    year: 2007,
    lifeExp: 39.613,
    pop: 1133066,
    gdpPercap: 4513.4806,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1952,
    lifeExp: 71.86,
    pop: 7124673,
    gdpPercap: 8527.8447,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1957,
    lifeExp: 72.49,
    pop: 7363802,
    gdpPercap: 9911.8782,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1962,
    lifeExp: 73.37,
    pop: 7561588,
    gdpPercap: 12329.4419,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1967,
    lifeExp: 74.16,
    pop: 7867931,
    gdpPercap: 15258.297,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1972,
    lifeExp: 74.72,
    pop: 8122293,
    gdpPercap: 17832.0246,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1977,
    lifeExp: 75.44,
    pop: 8251648,
    gdpPercap: 18855.7252,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1982,
    lifeExp: 76.42,
    pop: 8325260,
    gdpPercap: 20667.3812,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1987,
    lifeExp: 77.19,
    pop: 8421403,
    gdpPercap: 23586.9293,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1992,
    lifeExp: 78.16,
    pop: 8718867,
    gdpPercap: 23880.0168,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 1997,
    lifeExp: 79.39,
    pop: 8897619,
    gdpPercap: 25266.595,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 2002,
    lifeExp: 80.04,
    pop: 8954175,
    gdpPercap: 29341.6309,
  },
  {
    country: 'Sweden',
    continent: 'Europe',
    year: 2007,
    lifeExp: 80.884,
    pop: 9031088,
    gdpPercap: 33859.7484,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1952,
    lifeExp: 69.62,
    pop: 4815000,
    gdpPercap: 14734.2327,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1957,
    lifeExp: 70.56,
    pop: 5126000,
    gdpPercap: 17909.4897,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1962,
    lifeExp: 71.32,
    pop: 5666000,
    gdpPercap: 20431.0927,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1967,
    lifeExp: 72.77,
    pop: 6063000,
    gdpPercap: 22966.1443,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1972,
    lifeExp: 73.78,
    pop: 6401400,
    gdpPercap: 27195.113,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1977,
    lifeExp: 75.39,
    pop: 6316424,
    gdpPercap: 26982.2905,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1982,
    lifeExp: 76.21,
    pop: 6468126,
    gdpPercap: 28397.7151,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1987,
    lifeExp: 77.41,
    pop: 6649942,
    gdpPercap: 30281.7046,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1992,
    lifeExp: 78.03,
    pop: 6995447,
    gdpPercap: 31871.5303,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 1997,
    lifeExp: 79.37,
    pop: 7193761,
    gdpPercap: 32135.323,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 2002,
    lifeExp: 80.62,
    pop: 7361757,
    gdpPercap: 34480.9577,
  },
  {
    country: 'Switzerland',
    continent: 'Europe',
    year: 2007,
    lifeExp: 81.701,
    pop: 7554661,
    gdpPercap: 37506.4191,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1952,
    lifeExp: 45.883,
    pop: 3661549,
    gdpPercap: 1643.4854,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1957,
    lifeExp: 48.284,
    pop: 4149908,
    gdpPercap: 2117.2349,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1962,
    lifeExp: 50.305,
    pop: 4834621,
    gdpPercap: 2193.0371,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1967,
    lifeExp: 53.655,
    pop: 5680812,
    gdpPercap: 1881.9236,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1972,
    lifeExp: 57.296,
    pop: 6701172,
    gdpPercap: 2571.423,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1977,
    lifeExp: 61.195,
    pop: 7932503,
    gdpPercap: 3195.4846,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1982,
    lifeExp: 64.59,
    pop: 9410494,
    gdpPercap: 3761.8377,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1987,
    lifeExp: 66.974,
    pop: 11242847,
    gdpPercap: 3116.7743,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1992,
    lifeExp: 69.249,
    pop: 13219062,
    gdpPercap: 3340.5428,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 1997,
    lifeExp: 71.527,
    pop: 15081016,
    gdpPercap: 4014.239,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 2002,
    lifeExp: 73.053,
    pop: 17155814,
    gdpPercap: 4090.9253,
  },
  {
    country: 'Syria',
    continent: 'Asia',
    year: 2007,
    lifeExp: 74.143,
    pop: 19314747,
    gdpPercap: 4184.5481,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1952,
    lifeExp: 58.5,
    pop: 8550362,
    gdpPercap: 1206.9479,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1957,
    lifeExp: 62.4,
    pop: 10164215,
    gdpPercap: 1507.8613,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1962,
    lifeExp: 65.2,
    pop: 11918938,
    gdpPercap: 1822.879,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1967,
    lifeExp: 67.5,
    pop: 13648692,
    gdpPercap: 2643.8587,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1972,
    lifeExp: 69.39,
    pop: 15226039,
    gdpPercap: 4062.5239,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1977,
    lifeExp: 70.59,
    pop: 16785196,
    gdpPercap: 5596.5198,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1982,
    lifeExp: 72.16,
    pop: 18501390,
    gdpPercap: 7426.3548,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1987,
    lifeExp: 73.4,
    pop: 19757799,
    gdpPercap: 11054.5618,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1992,
    lifeExp: 74.26,
    pop: 20686918,
    gdpPercap: 15215.6579,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 1997,
    lifeExp: 75.25,
    pop: 21628605,
    gdpPercap: 20206.821,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 2002,
    lifeExp: 76.99,
    pop: 22454239,
    gdpPercap: 23235.4233,
  },
  {
    country: 'Taiwan',
    continent: 'Asia',
    year: 2007,
    lifeExp: 78.4,
    pop: 23174294,
    gdpPercap: 28718.2768,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1952,
    lifeExp: 41.215,
    pop: 8322925,
    gdpPercap: 716.6501,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1957,
    lifeExp: 42.974,
    pop: 9452826,
    gdpPercap: 698.5356,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1962,
    lifeExp: 44.246,
    pop: 10863958,
    gdpPercap: 722.0038,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1967,
    lifeExp: 45.757,
    pop: 12607312,
    gdpPercap: 848.2187,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1972,
    lifeExp: 47.62,
    pop: 14706593,
    gdpPercap: 915.9851,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1977,
    lifeExp: 49.919,
    pop: 17129565,
    gdpPercap: 962.4923,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1982,
    lifeExp: 50.608,
    pop: 19844382,
    gdpPercap: 874.2426,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1987,
    lifeExp: 51.535,
    pop: 23040630,
    gdpPercap: 831.8221,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1992,
    lifeExp: 50.44,
    pop: 26605473,
    gdpPercap: 825.6825,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 1997,
    lifeExp: 48.466,
    pop: 30686889,
    gdpPercap: 789.1862,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 2002,
    lifeExp: 49.651,
    pop: 34593779,
    gdpPercap: 899.0742,
  },
  {
    country: 'Tanzania',
    continent: 'Africa',
    year: 2007,
    lifeExp: 52.517,
    pop: 38139640,
    gdpPercap: 1107.4822,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1952,
    lifeExp: 50.848,
    pop: 21289402,
    gdpPercap: 757.7974,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1957,
    lifeExp: 53.63,
    pop: 25041917,
    gdpPercap: 793.5774,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1962,
    lifeExp: 56.061,
    pop: 29263397,
    gdpPercap: 1002.1992,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1967,
    lifeExp: 58.285,
    pop: 34024249,
    gdpPercap: 1295.4607,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1972,
    lifeExp: 60.405,
    pop: 39276153,
    gdpPercap: 1524.3589,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1977,
    lifeExp: 62.494,
    pop: 44148285,
    gdpPercap: 1961.2246,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1982,
    lifeExp: 64.597,
    pop: 48827160,
    gdpPercap: 2393.2198,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1987,
    lifeExp: 66.084,
    pop: 52910342,
    gdpPercap: 2982.6538,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1992,
    lifeExp: 67.298,
    pop: 56667095,
    gdpPercap: 4616.8965,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 1997,
    lifeExp: 67.521,
    pop: 60216677,
    gdpPercap: 5852.6255,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 2002,
    lifeExp: 68.564,
    pop: 62806748,
    gdpPercap: 5913.1875,
  },
  {
    country: 'Thailand',
    continent: 'Asia',
    year: 2007,
    lifeExp: 70.616,
    pop: 65068149,
    gdpPercap: 7458.3963,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1952,
    lifeExp: 38.596,
    pop: 1219113,
    gdpPercap: 859.8087,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1957,
    lifeExp: 41.208,
    pop: 1357445,
    gdpPercap: 925.9083,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1962,
    lifeExp: 43.922,
    pop: 1528098,
    gdpPercap: 1067.5348,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1967,
    lifeExp: 46.769,
    pop: 1735550,
    gdpPercap: 1477.5968,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1972,
    lifeExp: 49.759,
    pop: 2056351,
    gdpPercap: 1649.6602,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1977,
    lifeExp: 52.887,
    pop: 2308582,
    gdpPercap: 1532.777,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1982,
    lifeExp: 55.471,
    pop: 2644765,
    gdpPercap: 1344.578,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1987,
    lifeExp: 56.941,
    pop: 3154264,
    gdpPercap: 1202.2014,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1992,
    lifeExp: 58.061,
    pop: 3747553,
    gdpPercap: 1034.2989,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 1997,
    lifeExp: 58.39,
    pop: 4320890,
    gdpPercap: 982.2869,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 2002,
    lifeExp: 57.561,
    pop: 4977378,
    gdpPercap: 886.2206,
  },
  {
    country: 'Togo',
    continent: 'Africa',
    year: 2007,
    lifeExp: 58.42,
    pop: 5701579,
    gdpPercap: 882.9699,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1952,
    lifeExp: 59.1,
    pop: 662850,
    gdpPercap: 3023.2719,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1957,
    lifeExp: 61.8,
    pop: 764900,
    gdpPercap: 4100.3934,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1962,
    lifeExp: 64.9,
    pop: 887498,
    gdpPercap: 4997.524,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1967,
    lifeExp: 65.4,
    pop: 960155,
    gdpPercap: 5621.3685,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1972,
    lifeExp: 65.9,
    pop: 975199,
    gdpPercap: 6619.5514,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1977,
    lifeExp: 68.3,
    pop: 1039009,
    gdpPercap: 7899.5542,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1982,
    lifeExp: 68.832,
    pop: 1116479,
    gdpPercap: 9119.5286,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1987,
    lifeExp: 69.582,
    pop: 1191336,
    gdpPercap: 7388.5978,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1992,
    lifeExp: 69.862,
    pop: 1183669,
    gdpPercap: 7370.9909,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 1997,
    lifeExp: 69.465,
    pop: 1138101,
    gdpPercap: 8792.5731,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 2002,
    lifeExp: 68.976,
    pop: 1101832,
    gdpPercap: 11460.6002,
  },
  {
    country: 'Trinidad and Tobago',
    continent: 'Americas',
    year: 2007,
    lifeExp: 69.819,
    pop: 1056608,
    gdpPercap: 18008.5092,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1952,
    lifeExp: 44.6,
    pop: 3647735,
    gdpPercap: 1468.4756,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1957,
    lifeExp: 47.1,
    pop: 3950849,
    gdpPercap: 1395.2325,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1962,
    lifeExp: 49.579,
    pop: 4286552,
    gdpPercap: 1660.3032,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1967,
    lifeExp: 52.053,
    pop: 4786986,
    gdpPercap: 1932.3602,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1972,
    lifeExp: 55.602,
    pop: 5303507,
    gdpPercap: 2753.286,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1977,
    lifeExp: 59.837,
    pop: 6005061,
    gdpPercap: 3120.8768,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1982,
    lifeExp: 64.048,
    pop: 6734098,
    gdpPercap: 3560.2332,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1987,
    lifeExp: 66.894,
    pop: 7724976,
    gdpPercap: 3810.4193,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1992,
    lifeExp: 70.001,
    pop: 8523077,
    gdpPercap: 4332.7202,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 1997,
    lifeExp: 71.973,
    pop: 9231669,
    gdpPercap: 4876.7986,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 2002,
    lifeExp: 73.042,
    pop: 9770575,
    gdpPercap: 5722.8957,
  },
  {
    country: 'Tunisia',
    continent: 'Africa',
    year: 2007,
    lifeExp: 73.923,
    pop: 10276158,
    gdpPercap: 7092.923,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1952,
    lifeExp: 43.585,
    pop: 22235677,
    gdpPercap: 1969.101,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1957,
    lifeExp: 48.079,
    pop: 25670939,
    gdpPercap: 2218.7543,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1962,
    lifeExp: 52.098,
    pop: 29788695,
    gdpPercap: 2322.8699,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1967,
    lifeExp: 54.336,
    pop: 33411317,
    gdpPercap: 2826.3564,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1972,
    lifeExp: 57.005,
    pop: 37492953,
    gdpPercap: 3450.6964,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1977,
    lifeExp: 59.507,
    pop: 42404033,
    gdpPercap: 4269.1223,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1982,
    lifeExp: 61.036,
    pop: 47328791,
    gdpPercap: 4241.3563,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1987,
    lifeExp: 63.108,
    pop: 52881328,
    gdpPercap: 5089.0437,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1992,
    lifeExp: 66.146,
    pop: 58179144,
    gdpPercap: 5678.3483,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 1997,
    lifeExp: 68.835,
    pop: 63047647,
    gdpPercap: 6601.4299,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 2002,
    lifeExp: 70.845,
    pop: 67308928,
    gdpPercap: 6508.0857,
  },
  {
    country: 'Turkey',
    continent: 'Europe',
    year: 2007,
    lifeExp: 71.777,
    pop: 71158647,
    gdpPercap: 8458.2764,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1952,
    lifeExp: 39.978,
    pop: 5824797,
    gdpPercap: 734.7535,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1957,
    lifeExp: 42.571,
    pop: 6675501,
    gdpPercap: 774.3711,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1962,
    lifeExp: 45.344,
    pop: 7688797,
    gdpPercap: 767.2717,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1967,
    lifeExp: 48.051,
    pop: 8900294,
    gdpPercap: 908.9185,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1972,
    lifeExp: 51.016,
    pop: 10190285,
    gdpPercap: 950.7359,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1977,
    lifeExp: 50.35,
    pop: 11457758,
    gdpPercap: 843.7331,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1982,
    lifeExp: 49.849,
    pop: 12939400,
    gdpPercap: 682.2662,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1987,
    lifeExp: 51.509,
    pop: 15283050,
    gdpPercap: 617.7244,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1992,
    lifeExp: 48.825,
    pop: 18252190,
    gdpPercap: 644.1708,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 1997,
    lifeExp: 44.578,
    pop: 21210254,
    gdpPercap: 816.5591,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 2002,
    lifeExp: 47.813,
    pop: 24739869,
    gdpPercap: 927.721,
  },
  {
    country: 'Uganda',
    continent: 'Africa',
    year: 2007,
    lifeExp: 51.542,
    pop: 29170398,
    gdpPercap: 1056.3801,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1952,
    lifeExp: 69.18,
    pop: 50430000,
    gdpPercap: 9979.5085,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1957,
    lifeExp: 70.42,
    pop: 51430000,
    gdpPercap: 11283.1779,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1962,
    lifeExp: 70.76,
    pop: 53292000,
    gdpPercap: 12477.1771,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1967,
    lifeExp: 71.36,
    pop: 54959000,
    gdpPercap: 14142.8509,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1972,
    lifeExp: 72.01,
    pop: 56079000,
    gdpPercap: 15895.1164,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1977,
    lifeExp: 72.76,
    pop: 56179000,
    gdpPercap: 17428.7485,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1982,
    lifeExp: 74.04,
    pop: 56339704,
    gdpPercap: 18232.4245,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1987,
    lifeExp: 75.007,
    pop: 56981620,
    gdpPercap: 21664.7877,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1992,
    lifeExp: 76.42,
    pop: 57866349,
    gdpPercap: 22705.0925,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 1997,
    lifeExp: 77.218,
    pop: 58808266,
    gdpPercap: 26074.5314,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 2002,
    lifeExp: 78.471,
    pop: 59912431,
    gdpPercap: 29478.9992,
  },
  {
    country: 'United Kingdom',
    continent: 'Europe',
    year: 2007,
    lifeExp: 79.425,
    pop: 60776238,
    gdpPercap: 33203.2613,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1952,
    lifeExp: 68.44,
    pop: 157553000,
    gdpPercap: 13990.4821,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1957,
    lifeExp: 69.49,
    pop: 171984000,
    gdpPercap: 14847.1271,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1962,
    lifeExp: 70.21,
    pop: 186538000,
    gdpPercap: 16173.1459,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1967,
    lifeExp: 70.76,
    pop: 198712000,
    gdpPercap: 19530.3656,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1972,
    lifeExp: 71.34,
    pop: 209896000,
    gdpPercap: 21806.0359,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1977,
    lifeExp: 73.38,
    pop: 220239000,
    gdpPercap: 24072.6321,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1982,
    lifeExp: 74.65,
    pop: 232187835,
    gdpPercap: 25009.5591,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1987,
    lifeExp: 75.02,
    pop: 242803533,
    gdpPercap: 29884.3504,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1992,
    lifeExp: 76.09,
    pop: 256894189,
    gdpPercap: 32003.9322,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 1997,
    lifeExp: 76.81,
    pop: 272911760,
    gdpPercap: 35767.433,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 2002,
    lifeExp: 77.31,
    pop: 287675526,
    gdpPercap: 39097.0995,
  },
  {
    country: 'United States',
    continent: 'Americas',
    year: 2007,
    lifeExp: 78.242,
    pop: 301139947,
    gdpPercap: 42951.6531,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1952,
    lifeExp: 66.071,
    pop: 2252965,
    gdpPercap: 5716.7667,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1957,
    lifeExp: 67.044,
    pop: 2424959,
    gdpPercap: 6150.773,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1962,
    lifeExp: 68.253,
    pop: 2598466,
    gdpPercap: 5603.3577,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1967,
    lifeExp: 68.468,
    pop: 2748579,
    gdpPercap: 5444.6196,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1972,
    lifeExp: 68.673,
    pop: 2829526,
    gdpPercap: 5703.4089,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1977,
    lifeExp: 69.481,
    pop: 2873520,
    gdpPercap: 6504.3397,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1982,
    lifeExp: 70.805,
    pop: 2953997,
    gdpPercap: 6920.2231,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1987,
    lifeExp: 71.918,
    pop: 3045153,
    gdpPercap: 7452.399,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1992,
    lifeExp: 72.752,
    pop: 3149262,
    gdpPercap: 8137.0048,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 1997,
    lifeExp: 74.223,
    pop: 3262838,
    gdpPercap: 9230.2407,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 2002,
    lifeExp: 75.307,
    pop: 3363085,
    gdpPercap: 7727.002,
  },
  {
    country: 'Uruguay',
    continent: 'Americas',
    year: 2007,
    lifeExp: 76.384,
    pop: 3447496,
    gdpPercap: 10611.463,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1952,
    lifeExp: 55.088,
    pop: 5439568,
    gdpPercap: 7689.7998,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1957,
    lifeExp: 57.907,
    pop: 6702668,
    gdpPercap: 9802.4665,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1962,
    lifeExp: 60.77,
    pop: 8143375,
    gdpPercap: 8422.9742,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1967,
    lifeExp: 63.479,
    pop: 9709552,
    gdpPercap: 9541.4742,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1972,
    lifeExp: 65.712,
    pop: 11515649,
    gdpPercap: 10505.2597,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1977,
    lifeExp: 67.456,
    pop: 13503563,
    gdpPercap: 13143.951,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1982,
    lifeExp: 68.557,
    pop: 15620766,
    gdpPercap: 11152.4101,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1987,
    lifeExp: 70.19,
    pop: 17910182,
    gdpPercap: 9883.5846,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1992,
    lifeExp: 71.15,
    pop: 20265563,
    gdpPercap: 10733.9263,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 1997,
    lifeExp: 72.146,
    pop: 22374398,
    gdpPercap: 10165.4952,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 2002,
    lifeExp: 72.766,
    pop: 24287670,
    gdpPercap: 8605.0478,
  },
  {
    country: 'Venezuela',
    continent: 'Americas',
    year: 2007,
    lifeExp: 73.747,
    pop: 26084662,
    gdpPercap: 11415.8057,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1952,
    lifeExp: 40.412,
    pop: 26246839,
    gdpPercap: 605.0665,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1957,
    lifeExp: 42.887,
    pop: 28998543,
    gdpPercap: 676.2854,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1962,
    lifeExp: 45.363,
    pop: 33796140,
    gdpPercap: 772.0492,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1967,
    lifeExp: 47.838,
    pop: 39463910,
    gdpPercap: 637.1233,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1972,
    lifeExp: 50.254,
    pop: 44655014,
    gdpPercap: 699.5016,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1977,
    lifeExp: 55.764,
    pop: 50533506,
    gdpPercap: 713.5371,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1982,
    lifeExp: 58.816,
    pop: 56142181,
    gdpPercap: 707.2358,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1987,
    lifeExp: 62.82,
    pop: 62826491,
    gdpPercap: 820.7994,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1992,
    lifeExp: 67.662,
    pop: 69940728,
    gdpPercap: 989.0231,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 1997,
    lifeExp: 70.672,
    pop: 76048996,
    gdpPercap: 1385.8968,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 2002,
    lifeExp: 73.017,
    pop: 80908147,
    gdpPercap: 1764.4567,
  },
  {
    country: 'Vietnam',
    continent: 'Asia',
    year: 2007,
    lifeExp: 74.249,
    pop: 85262356,
    gdpPercap: 2441.5764,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1952,
    lifeExp: 43.16,
    pop: 1030585,
    gdpPercap: 1515.5923,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1957,
    lifeExp: 45.671,
    pop: 1070439,
    gdpPercap: 1827.0677,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1962,
    lifeExp: 48.127,
    pop: 1133134,
    gdpPercap: 2198.9563,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1967,
    lifeExp: 51.631,
    pop: 1142636,
    gdpPercap: 2649.715,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1972,
    lifeExp: 56.532,
    pop: 1089572,
    gdpPercap: 3133.4093,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1977,
    lifeExp: 60.765,
    pop: 1261091,
    gdpPercap: 3682.8315,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1982,
    lifeExp: 64.406,
    pop: 1425876,
    gdpPercap: 4336.0321,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1987,
    lifeExp: 67.046,
    pop: 1691210,
    gdpPercap: 5107.1974,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1992,
    lifeExp: 69.718,
    pop: 2104779,
    gdpPercap: 6017.6548,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 1997,
    lifeExp: 71.096,
    pop: 2826046,
    gdpPercap: 7110.6676,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 2002,
    lifeExp: 72.37,
    pop: 3389578,
    gdpPercap: 4515.4876,
  },
  {
    country: 'West Bank and Gaza',
    continent: 'Asia',
    year: 2007,
    lifeExp: 73.422,
    pop: 4018332,
    gdpPercap: 3025.3498,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1952,
    lifeExp: 32.548,
    pop: 4963829,
    gdpPercap: 781.7176,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1957,
    lifeExp: 33.97,
    pop: 5498090,
    gdpPercap: 804.8305,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1962,
    lifeExp: 35.18,
    pop: 6120081,
    gdpPercap: 825.6232,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1967,
    lifeExp: 36.984,
    pop: 6740785,
    gdpPercap: 862.4421,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1972,
    lifeExp: 39.848,
    pop: 7407075,
    gdpPercap: 1265.047,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1977,
    lifeExp: 44.175,
    pop: 8403990,
    gdpPercap: 1829.7652,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1982,
    lifeExp: 49.113,
    pop: 9657618,
    gdpPercap: 1977.557,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1987,
    lifeExp: 52.922,
    pop: 11219340,
    gdpPercap: 1971.7415,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1992,
    lifeExp: 55.599,
    pop: 13367997,
    gdpPercap: 1879.4967,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 1997,
    lifeExp: 58.02,
    pop: 15826497,
    gdpPercap: 2117.4845,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 2002,
    lifeExp: 60.308,
    pop: 18701257,
    gdpPercap: 2234.8208,
  },
  {
    country: 'Yemen, Rep.',
    continent: 'Asia',
    year: 2007,
    lifeExp: 62.698,
    pop: 22211743,
    gdpPercap: 2280.7699,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1952,
    lifeExp: 42.038,
    pop: 2672000,
    gdpPercap: 1147.3888,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1957,
    lifeExp: 44.077,
    pop: 3016000,
    gdpPercap: 1311.9568,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1962,
    lifeExp: 46.023,
    pop: 3421000,
    gdpPercap: 1452.7258,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1967,
    lifeExp: 47.768,
    pop: 3900000,
    gdpPercap: 1777.0773,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1972,
    lifeExp: 50.107,
    pop: 4506497,
    gdpPercap: 1773.4983,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1977,
    lifeExp: 51.386,
    pop: 5216550,
    gdpPercap: 1588.6883,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1982,
    lifeExp: 51.821,
    pop: 6100407,
    gdpPercap: 1408.6786,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1987,
    lifeExp: 50.821,
    pop: 7272406,
    gdpPercap: 1213.3151,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1992,
    lifeExp: 46.1,
    pop: 8381163,
    gdpPercap: 1210.8846,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 1997,
    lifeExp: 40.238,
    pop: 9417789,
    gdpPercap: 1071.3538,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 2002,
    lifeExp: 39.193,
    pop: 10595811,
    gdpPercap: 1071.6139,
  },
  {
    country: 'Zambia',
    continent: 'Africa',
    year: 2007,
    lifeExp: 42.384,
    pop: 11746035,
    gdpPercap: 1271.2116,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1952,
    lifeExp: 48.451,
    pop: 3080907,
    gdpPercap: 406.8841,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1957,
    lifeExp: 50.469,
    pop: 3646340,
    gdpPercap: 518.7643,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1962,
    lifeExp: 52.358,
    pop: 4277736,
    gdpPercap: 527.2722,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1967,
    lifeExp: 53.995,
    pop: 4995432,
    gdpPercap: 569.7951,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1972,
    lifeExp: 55.635,
    pop: 5861135,
    gdpPercap: 799.3622,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1977,
    lifeExp: 57.674,
    pop: 6642107,
    gdpPercap: 685.5877,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1982,
    lifeExp: 60.363,
    pop: 7636524,
    gdpPercap: 788.855,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1987,
    lifeExp: 62.351,
    pop: 9216418,
    gdpPercap: 706.1573,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1992,
    lifeExp: 60.377,
    pop: 10704340,
    gdpPercap: 693.4208,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 1997,
    lifeExp: 46.809,
    pop: 11404948,
    gdpPercap: 792.45,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 2002,
    lifeExp: 39.989,
    pop: 11926563,
    gdpPercap: 672.0386,
  },
  {
    country: 'Zimbabwe',
    continent: 'Africa',
    year: 2007,
    lifeExp: 43.487,
    pop: 12311143,
    gdpPercap: 469.7093,
  },
]
